import React, { useState, useEffect, Fragment, useRef, useMemo, createContext, useContext } from 'react'
import { Paper, Chip, Accordion,ButtonGroup, CircularProgress, Divider, IconButton, ClickAwayListener, Menu, Popper, Tooltip, AccordionDetails, Typography, Stepper, Step, StepLabel, StepContent, StepButton, Button, InputLabel, MenuItem, FormControl, Select, TextField, ListItemIcon, Avatar, ListItemText, Grid, AccordionSummary, InputAdornment, Modal, Radio } from '@material-ui/core'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Form from "@rjsf/material-ui";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import RefreshRoundedIcon from '@material-ui/icons/RefreshRounded';
import RadioButtonUncheckedOutlinedIcon from '@material-ui/icons/RadioButtonUncheckedOutlined';
import RadioButtonCheckedOutlinedIcon from '@material-ui/icons/RadioButtonCheckedOutlined';
import { makeStyles, useTheme, Theme, createStyles } from '@material-ui/core/styles';
import ReactDOM from "react-dom";
import { createPortal } from 'react-dom';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import Inspector2 from 'react-json-inspector';
import '../helpers/json-inspector-dropdown.css';
import '../helpers/workload-mode-style.css';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import UnfoldMoreRoundedIcon from '@material-ui/icons/UnfoldMoreRounded';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import ArrowUpwardRoundedIcon from '@material-ui/icons/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@material-ui/icons/ArrowDownwardRounded';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import 'codemirror/theme/neat.css';


//import {Decoration} from "@codemirror/state"

import {
    nodeAdded, edgeAdded, elementUpdated, nameUpdated, elementDeleted, fetchWorkflow, nodeEdgeAdded, saveWorkflow, elementSelected, testNode, loadingperform,
    selectWorkflowElements, selectElementById, selectWorkflowName, selectWorkflowId, selectParentTree, selectWorkflowTemplateNodes, selectWorkflowActive, selectCurrentElement
} from '../../features/workflow/workflowSlice'

import {
    selectExecutionParentTree, selectCurrentElement as selectExecutionCurrentElement
} from '../../features/execution/executionSlice'

import { Autocomplete } from '@material-ui/lab';
import SearchRounded from '@material-ui/icons/SearchRounded';
import { setDefaultResultOrder } from 'dns';
import { createSemanticDiagnosticsBuilderProgram } from 'typescript';
import { ExpandMore } from '@material-ui/icons';
import { getUnmetDynamicParams } from '../../utils/dynamicFieldDeps';
import { mergePerformBody, deepMergeSchemaProperties, preservePerformValues } from '../../utils/performFields';

Object.byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    var a = s.split('.');

    if (s == '') {
        return o
    }
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    removeappbutton: {
        '& > *': {
            margin: theme.spacing(1),

        },
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    actionsContainer: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(1),
    },
    selectInput: {
        '*': {
            display: 'flex'
        }
    },
    chiproot: {
        display: 'flex',
        left: 5,
        marginLeft: '4px',
        marginRight: '4px',
        width: '99%',
        float: 'left',
        '& > *': {
            margin: '-10px',

        },
        "& > *:hover": {

        }
    },
    accordionroot: {
        width: '90px',
    },
    accordionheading: {
        fontWeight: 700,
        width: '100%'
    },
    dropdownroot: {
        position: 'relative',
    },
    radio: {
        '&:hover': {
          fontWeight: 'bolder',
    
        },
      },
    small: {
        width: '22px',
        height: '22px',
        marginRight: '4px'
    },
    dropdown: {
        position: 'fixed', // Use fixed positioning since it's now in a portal
        width: '450px', // Width for the dropdown
        right: '35vw', // Position from left edge of viewport
        //top: '100px', // Position from top edge of viewport
        marginLeft: '0px', // No margin since we're positioning with left/top

        zIndex: 3, // Higher z-index to ensure it's above everything
        // borderTop: '1px solid',
        borderLeft: '1px solid',
        boxShadow: theme.palette.type === 'dark' ? "rgba(0, 0, 0, 0.5) 0px 10px 30px 0px" : "rgba(0, 0, 0, 0.2) 0px 10px 30px 0px",
        borderColor: theme.palette.type === 'dark' ? theme.palette.divider : 'lightgrey',
        borderRadius: '5px',
        padding: '0px 4px 4px 0px',
        opacity: '1',
        overflowX: "hidden",
        height: 'auto',
        maxHeight: '550px',
        overflowY: "auto",

    },
    codemirror: {
        marginTop: '7px',
   
        border: '1px solid',
        borderColor: theme.palette.type === 'dark' ? theme.palette.divider : 'lightgrey',
        borderRadius: '4px',
        //paddingTop: '2px',
        paddingRight: '8px',
        paddingBottom: '6px',
       
        width: 'inherit',
        height: 'auto',
        // display: 'relative',
        overflowX: 'hidden',
        //position: 'absolute'
        '&:hover': {
            borderColor: theme.palette.type === 'dark' ? theme.palette.text.primary : 'black',
            border: '1px solid'
        },
        '&:focus-within': {
            borderColor: theme.palette.primary.main,
            border: '2px solid'
        }
    },
    // Add pointer cursor on CodeMirror lines for dynamic fields only
    codemirrorDynamic: {
        '& .CodeMirror pre': {
            cursor: 'pointer'
        }
    },
    resetContainer: {
        padding: theme.spacing(1),
    },
    modal: {
        position: 'absolute',
        width: 800,
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

const ChipContextMenu = ({ parentRef, info }) => {
    const theme = useTheme();
    const [visible, setVisible] = useState(false)
    const [x, setX] = useState(0)
    const [y, setY] = useState(0)

    const items = [
        {
            text: 'Remove Reference',
            onClick: info.deleteClick
        }
    ]
    useEffect(() => {
        const parent = parentRef.current;
        if (!parent) {
            return
        }

        const showMenu = (event) => {
            event.preventDefault();


            setVisible(true)
            setX(event.clientX)
            setY(event.clientY - 20)

        }

        const closeMenu = () => {
            setVisible(false)
        }

        parent.addEventListener('contextmenu', showMenu)
        window.addEventListener('click', closeMenu)

        return function cleanup() {
            parent.removeEventListener('contextmenu', showMenu)
            window.removeEventListener('click', closeMenu)
        }
    })

    return visible ? (

        <div className='chip-context-menu' style={{ top: y, left: x, position: 'fixed', backgroundColor: theme.palette.background.paper, marginBottom: '200px', zIndex: 999 }}>

            {items.map(el => {
                return <MenuItem onClick={el.onClick}>{el.text}</MenuItem>
            })}

        </div>

    ) : null
}

// Component to wrap Inspector2 and inject app icons
const InspectorWrapperWithIcon = ({ iconUrl, nodeKey, children }) => {
    const wrapperRef = useRef(null);
    
    // Ensure clicks inside the inspector are not blocked
    useEffect(() => {
        if (!wrapperRef.current) return;
        
        const handleClick = (e) => {
            // Check if click is on an Inspector value (which should trigger onClick)
            const isInspectorValueClick = e.target.closest('.json-inspector__value') || 
                                         e.target.closest('.json-inspector__key');
            
            // If it's a value click, don't stop propagation - let Inspector handle it
            if (isInspectorValueClick) {
                // Just suppress click-away, but don't stop propagation
                if (typeof window !== 'undefined') {
                    window.wfSuppressClickAwayUntil = Date.now() + 500;
                }
                return; // Let the event continue to Inspector's onClick
            }
            
            // For other clicks (like on the wrapper itself), stop propagation
            e.stopPropagation();
            // Suppress click-away detection
            if (typeof window !== 'undefined') {
                window.wfSuppressClickAwayUntil = Date.now() + 500;
            }
        };
        
        const wrapper = wrapperRef.current;
        wrapper.addEventListener('click', handleClick, true); // Use capture phase
        
        return () => {
            wrapper.removeEventListener('click', handleClick, true);
        };
    }, []);
    
    useEffect(() => {
        if (!wrapperRef.current || !iconUrl) return;
        
        const injectIcons = () => {
            const lines = wrapperRef.current.querySelectorAll('.json-inspector__line');
            lines.forEach((line) => {
                // Hide lines with "root" key - check if the key text contains "root"
                const keyElement = line.querySelector('.json-inspector__key');
                if (keyElement) {
                    const keyText = keyElement.textContent.trim();
                    // Hide if it's exactly "root" or starts with "root:"
                    if (keyText === 'root' || keyText.startsWith('root:')) {
                        line.classList.add('hide-root');
                        // Also hide the parent leaf if it only contains root
                        const leaf = line.closest('.json-inspector__leaf');
                        if (leaf) {
                            const allKeys = leaf.querySelectorAll('.json-inspector__key');
                            if (allKeys.length === 1 && allKeys[0].textContent.trim() === 'root') {
                                leaf.style.display = 'none';
                            }
                        }
                        return;
                    }
                }
                
                // Skip if already has icon
                if (line.querySelector('.json-inspector-icon')) {
                    return;
                }
                
                // Truncate long string values (over 300 characters)
                const valueElement = line.querySelector('.json-inspector__value');
                if (valueElement) {
                    // Skip if already truncated (has data-original attribute)
                    if (!valueElement.hasAttribute('data-original')) {
                        const originalText = valueElement.textContent || valueElement.innerText || '';
                        if (originalText.length > 300) {
                            const truncated = originalText.substring(0, 300) + '...';
                            valueElement.textContent = truncated;
                            // Store original in data attribute for potential future use
                            valueElement.setAttribute('data-original', originalText);
                        }
                    }
                }
                
                // Add icon to all top-level lines (direct children of json-inspector or first level within composites)
                // Check if this is a direct child line or a top-level line by checking parent structure
                const parent = line.parentElement;
                const isTopLevel = !parent?.closest('.json-inspector__line') || parent.classList.contains('json-inspector');
                
                if (isTopLevel) {
                    const iconElement = document.createElement('span');
                    iconElement.className = 'json-inspector-icon';
                    iconElement.style.cssText = `
                        position: absolute;
                        left: 10px;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 14px;
                        height: 14px;
                        background-image: url('${iconUrl}');
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                        z-index: 1;
                        border-radius: 3px;
                        pointer-events: none;
                    `;
                    line.appendChild(iconElement);
                }
            });
        };
        
        // Inject icons after a short delay to allow Inspector2 to render
        const timeoutId = setTimeout(injectIcons, 100);
        
        // Also observe for new lines added dynamically
        const observer = new MutationObserver(injectIcons);
        observer.observe(wrapperRef.current, { childList: true, subtree: true });
        
        return () => {
            clearTimeout(timeoutId);
            observer.disconnect();
        };
    }, [iconUrl, nodeKey]);
    
    return (
        <div ref={wrapperRef} className="inspector-wrapper-with-icon" data-icon-url={iconUrl} style={{ width: '100%', display: 'block' }}>
            {children}
        </div>
    );
};

const DynamicChip = (props) => {
    const theme = useTheme();
    const widgetRef = useRef(null)
    
    return (
        <>
            <span style={{ fontFamily: theme.typography.fontFamily, fontSize: '14px', padding: '7px 8px 4px 14px', border: `1px solid ${theme.palette.primary.main}`, borderRadius: '4px' }} ref={widgetRef}>
                <img
                    className="tag-img"
                    src={props.icon}>
                </img>
                <b>{props.label}</b>
            </span>
            <ChipContextMenu parentRef={widgetRef} info={props} />
        </>
    )
}

const WorkflowChip = (props) => {
    const theme = useTheme();
    const widgetRef = useRef(null)

    return (
        <>
            <span style={{ 
                fontSize: '14px', 
                padding: '7px 8px 4px 14px', 
                border: `1px solid ${theme.palette.primary.main}`, 
                borderRadius: '4px',
                //backgroundColor: theme.palette.background.default,
                //color: theme.palette.text.primary,
                //display: 'inline-block',
                maxWidth: '300px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                
            }} ref={widgetRef}>
                <img
                    className="tag-img"
                    src={props.icon}
                    //style={{ verticalAlign: 'middle', marginRight: '4px' }}
                />
                <div style={{display: 'inline', textTransform: 'uppercase' }}>
                    <b>{props.step ? props.step + "." : ""} {props.label}: </b>
                </div>
                <div style={{ display: 'inline', color: 'gray'}}>
                    {props.cvalue?.length > 30 ? props.cvalue.substring(0, 30) + '...' : props.cvalue}
                </div>
            </span>
            <ChipContextMenu parentRef={widgetRef} info={props} />
        </>
    )
}

const ExecutionChip = (props) => {
    const theme = useTheme();
    const widgetRef = useRef(null)

    return (
        <>
            <span style={{ 
                fontSize: '14px', 
                padding: '7px 8px 2px 14px', 
                border: `1px solid ${theme.palette.primary.main}`, 
                borderRadius: '4px',
                display: 'inline-block',
                maxWidth: '300px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                verticalAlign: 'top',
                color: theme.palette.text.primary
            }} ref={widgetRef}>
                <img
                    className="tag-img"
                    src={props.icon}
                    style={{ verticalAlign: 'middle', marginRight: '4px' }}
                />
                <div style={{display: 'inline', textTransform: 'uppercase' }}>
                    <b>{props.label}: </b>
                </div>
                <div style={{ display: 'inline', color: theme.palette.text.secondary }}>
                    {props.cvalue?.length > 30 ? props.cvalue.substring(0, 30) + '...' : props.cvalue}
                </div>
            </span>
            <ChipContextMenu parentRef={widgetRef} info={props} />
        </>
    )
}

const ExecutionWidget = (props, id) => {

    const [value, setValue] = useState(props.value);
    const [open, setOpen] = useState(false);
    const parentTree = useSelector(selectExecutionParentTree);
    const nodeId = useSelector(selectExecutionCurrentElement);
    const nodeData = useSelector(selectElementById(nodeId))
    const parents = parentTree[nodeId];

    const widgetRe = /\${(([^}][^}]?|[^}]}?)*)}/;
    const widgetRe2 = /[\s\S]+/;
    const classes = useStyles()
    const prettyOptions = {
        mode: { name: 'workload-mode', type: 'text/html' },
        lineNumbers: false,
        cursorHeight: 1.25,
        fullScreen: false,
        scrollbarStyle: null,
        lineWrapping: false,
        extraKeys: {Tab: false, "Shift-Tab": false},
        theme: 'neat',
        readOnly: props.disabled ? "nocursor" : false
    }

    const handleClickAway = () => {
        setOpen(false)
    }

    const handleChange2 = (editor, data, value) => {
        setValue(value)
        const cursor = editor.getSearchCursor(props.schema.dynamic ? widgetRe2 : widgetRe, 0, { multiline: 'disable' })
       
        while (cursor.findNext()) {
            
            const stringMatch = editor.getRange(cursor.from(), cursor.to()).match(props.schema.dynamic ? widgetRe2 : widgetRe)[1]
            const doc = editor.getDoc()
           
            var currNode = document.createElement('span')

            try {
                const refInfo = props.schema.dynamic ? null : stringMatch.split('.') //format nodes.{nodeID}.outputFields.{refString...}
                if (props.schema.dynamic){

                    var fromObj = cursor.from()
                    var toObj = cursor.to()
                  
                ReactDOM.render(<DynamicChip deleteClick={() => doc.replaceRange("", fromObj, toObj)} icon={nodeData.data.icon}  label={value}  />, currNode)
                    
                } else {
                    
                const refNodeID = refInfo[1]
                const testDataRefString = refInfo.slice(3).join('.')
                const refNode = parents[refNodeID]
                const matchData = Object.byString(refNode.data.testData, testDataRefString)

                var fromObj = cursor.from()
                var toObj = cursor.to()
                // Build display pieces
                const fullKey = refInfo.slice(3).join('.');           // "data.user.email" style
                const stepNum = parents[refNodeID]?.position || '';   // step number in the left column
                const iconUrl = parents[refNodeID]?.data?.icon || null;
                const displayVal = (matchData != null && typeof matchData !== 'object')
                ? String(matchData)
                : JSON.stringify(matchData);
                
                ReactDOM.render(
                <ExecutionChip
                    //deleteClick={() => doDelete(editor, fromObj, toObj)}
                    icon={iconUrl}
                    step={stepNum}
                    label={fullKey}
                    cvalue={displayVal}
                />,
                currNode
                )
               
                    }
                }
            catch (e) {
             
                ReactDOM.render(<ExecutionChip icon={null} step={'replacelabel'} label={"Unknown Reference"} cvalue={"N/A"} />, currNode)
            }

            editor.markText(cursor.from(), cursor.to(), { replacedWith: currNode })
        }
       
    }


    return (
        <ClickAwayListener key={id + 'cc'} onClickAway={handleClickAway}>
            <div  key={id + 'dv'} style={{ padding: '2px 8px 2px 8px' }} 
                  onFocus={(e) => {
                    if (e.currentTarget === e.target) {
                    } else {
                        setOpen(true);
                    }
                  }}
                  onClick={() => {}}>
                <div key={id + 'ddv'} id='codemirror-wrapper' className={classes.codemirror} >
                    <CodeMirror
                        id={props.id}
                        defaultValue={value}
                        value={value ?? ''}
                        // height='45px'
                        options={prettyOptions}
                        onChange={(editor, data, value) => { handleChange2(editor, data, value); props.onChange(value) }}
                        // onUpdate={(editor) => handleUpdate(editor)}
                        // onCursorActivity={updateSelection}
                        autoCursor={false}
                    />
                </div>
            </div>
        </ClickAwayListener>
    )
}

export function FilterWidget({
  props,
  sendData = null
}) {

  return (
    <WorkflowWidget props={props} />
  )
}


const CustomSelectWidget = ({
    props,
    id,
    schemaObj,
    setFields,
    sendData = null,
    initVal,
    ky,
    styleClass,
    activeFieldId = null,
    openAccordionId = null,
    setOpenAccordionId = () => {}
  }) => {
    const theme = useTheme();
    const parentTree = useSelector(selectParentTree);
    const nodeId = useSelector(selectCurrentElement);
    const parents = parentTree[nodeId];
    const [tabValue, setTabValue] = useState(0);
    const [tabLabel, setTabLabel] = useState(props.schema.title);
    const [expanded, setExpanded] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [filteredResults, setFilteredResults] = useState([]);
    const [selected, setSelected] = useState('');
    const classes = useStyles();
    const icon = <RadioButtonUncheckedOutlinedIcon fontSize="small" />;
    const checkedIcon = <RadioButtonCheckedOutlinedIcon fontSize="small" />;
  
    const handleTabChange = (newValue) => setTabValue(newValue);
  
    const hoverOn = (value) => setSelected(value);
    const hoverOff = () => setSelected(null);
  
    const searchItems = (searchValue) => {
      setSearchInput(searchValue);
      if (searchValue) {
        // Filter enumOptions by matching enumNames, then return the full option objects
        const filteredOptions = props.options.enumOptions.filter((option) => 
          option.label.toLowerCase().includes(searchValue.toLowerCase())
        );
        setFilteredResults(filteredOptions);
      } else {
        setFilteredResults([]);
      }
    };
  
    const TabPanel = ({ children, value, index }) => (
      <div role="tabpanel" hidden={value !== index}>
        {value === index && <Box p={3}><Typography>{children}</Typography></Box>}
      </div>
    );
  
    TabPanel.propTypes = {
      children: PropTypes.node,
      index: PropTypes.any.isRequired,
      value: PropTypes.any.isRequired,
    };
  
    const a11yProps = (index) => ({
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    });
  
    const renderOptions = () => {
      // Determine which options to use: filtered results if searching, otherwise use enumOptions
      // Handle case where enumOptions might not exist (fallback to enum/enumNames)
      let enumOptions = null;
      if (searchInput.length > 0 && filteredResults.length > 0) {
        enumOptions = filteredResults;
      } else if (props.options && props.options.enumOptions) {
        enumOptions = props.options.enumOptions;
      } else if (props.schema.enum && props.schema.enumNames) {
        // Fallback: create enumOptions from enum and enumNames if props.options.enumOptions doesn't exist
        enumOptions = props.schema.enum.map((value, index) => ({
          value: value,
          label: props.schema.enumNames[index] || value
        }));
      } else if (props.schema.enum) {
        // Last fallback: just use enum values as both value and label
        enumOptions = props.schema.enum.map(value => ({
          value: value,
          label: value
        }));
      } else {
        enumOptions = [];
      }
      
      const booleanOptions = [{label: "Yes", value: true}, {label: "No", value: false}]
      let options = null
      if (props.schema.type === 'boolean') {
        options = booleanOptions
      } else {
        options = enumOptions
      }
      
      // Ensure options is an array before mapping
      if (!Array.isArray(options)) {
        options = [];
      }
      
      return options.map(option => {
        // Handle case where option might be a string (from old code)
        const optionValue = typeof option === 'object' && option !== null ? option.value : option;
        const optionLabel = typeof option === 'object' && option !== null ? option.label : option;
        
        const handleOptionClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.nativeEvent?.stopImmediatePropagation();
          // Suppress click-away detection
          if (typeof window !== 'undefined') {
            window.wfSuppressClickAwayUntil = Date.now() + 500;
          }
          if (sendData) {
            // Use setTimeout to ensure the click event has fully processed
            setTimeout(() => {
              sendData(optionValue);
            }, 0);
          }
          setExpanded(false);
        };
        
        return (
          <div key={optionValue}>
            <MenuItem
              className={classes.radio}
              id={String(optionValue)}
              onMouseEnter={() => hoverOn(optionValue)}
              onMouseLeave={hoverOff}
              onClick={handleOptionClick}
              onMouseDown={(e) => {
                // Prevent default to avoid any menu closing behavior
                e.preventDefault();
              }}
              style={{ cursor: 'pointer', userSelect: 'none' }}
            >
              <Radio
                id={String(optionValue)}
                color='primary'
                checkedIcon={checkedIcon}
                icon={icon}
                checked={selected === optionValue}
                value={optionValue}
                style={{ pointerEvents: 'none', border: 'none' }}
              />
              <Typography style={{color: theme.palette.text.primary, pointerEvents: 'none'}}>{optionLabel}</Typography>
            </MenuItem>
            <Typography style={{ marginTop: '-17px', marginLeft: '62px', fontSize: '11px', color: theme.palette.text.secondary, pointerEvents: 'none' }}>
              {String(optionValue)}
            </Typography>
          </div>
        );
      });
    };
    const inPortal = props?.usePortalLayout; // boolean
    const portalSafeStyle = { position: 'static', boxShadow: theme.palette.type === 'dark' ? 'rgba(0, 0, 0, 0.5) 0px 10px 30px 0px' : 'rgba(0, 0, 0, 0.2) 0px 10px 30px 0px', width: 'auto', background: theme.palette.background.paper, borderRadius: '0.5rem', border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : 'rgb(215, 211, 201)'}` };

  
    return (
        <div
        className={inPortal ? undefined : classes.dropdown}
        style={inPortal ? portalSafeStyle : undefined}
        >
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => handleTabChange(newValue)}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab {...a11yProps(0)} style={{ textTransform: 'none' }} label={tabLabel ?? 'Choose Option'} />
          <Tab {...a11yProps(1)} style={{ textTransform: 'none' }} label="Custom" />
        </Tabs>
  
        {tabValue === 0 && (
          <TextField
            onChange={(e) => searchItems(e.target.value)}
            style={{ width: '100%', marginBottom: '25px', marginTop: '10px' }}
            label="Search..."
            variant="outlined"
            value={searchInput}
            placeholder="Search..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon style={{ color: theme.palette.text.secondary }} />
                </InputAdornment>
              ),
            }}
          />
        )}
  
        <Divider variant="middle" />
  
        <TabPanel value={tabValue} index={0}>
          {props.schema.enum?.length > 0 || props.schema.type === 'boolean' ? renderOptions() : (
            <div>
              <LinearProgress color="primary" />
              <Skeleton animation="wave" height={34} />
              <Skeleton animation="wave" height={18} />
            </div>
          )}
          <div style={{marginTop: '10px',width: '100%', position:'absolute',zIndex: 9999}}>
          <Button style={{ marginBottom: '15px', width: '80%', textTransform: 'none',fontWeight: 600, fontSize: '16px'}} 
          variant='outlined'
          color="primary" 
          onClick={() => sendData(null)}>Clear Data
          </Button>
          </div>
  
        </TabPanel>
  
        <TabPanel value={tabValue} index={1}>
          <Typography style={{ fontSize: 14, fontWeight: 900, marginLeft: 25, paddingTop: 15, color: theme.palette.text.primary }}>Insert Data...</Typography>
          <Divider style={{ marginBottom: '10px' }} />
          {parents && Object.entries(parents).map(([k, v], i) => (
            <Accordion key={k} style={{ backgroundColor: theme.palette.background.paper }}>
              <AccordionSummary 
                expandIcon={<ExpandMoreIcon style={{ color: theme.palette.text.primary }} />}
                style={{ backgroundColor: theme.palette.background.paper }}
              >
                <Avatar alt={v.data.label} src={v.data.icon} className={classes.small} />
                <Typography className={classes.accordionheading} style={{ color: theme.palette.text.primary }}>{i + 1}. {v.data.name}</Typography>
              </AccordionSummary>
              <AccordionDetails style={{ backgroundColor: theme.palette.background.paper }}>
                <div className={classes.chiproot}>
                  {!v.data.testData ? (
                    <Typography style={{ marginLeft: '5%', color: theme.palette.getContrastText(theme.palette.error.main), fontWeight: 'bold', backgroundColor: theme.palette.error.main, borderRadius: '20px' }}>
                      Error: No data to insert...
                    </Typography>
                  ) : (
                    <InspectorWrapperWithIcon iconUrl={v.data.icon} nodeKey={k}>
                    <Inspector2
                      id={k}
                        data={v.data.testData && typeof v.data.testData === 'object' && 'Output' in v.data.testData ? v.data.testData : { Output: v.data.testData }}
                      isExpanded={() => true}
                      onClick={(e) => {
                          if (sendData) {
                            // Adjust path to account for "Output" wrapper - remove "t." and "Output." prefixes if present
                            let adjustedPath = e.path !== 't' ? e.path : '';
                            // Remove "t." prefix if present (e.g., "t.Output.field" -> "Output.field")
                            if (adjustedPath && adjustedPath.startsWith('t.')) {
                              adjustedPath = adjustedPath.substring(2);
                            }
                            // Remove "Output." prefix if present (e.g., "Output.field" -> "field")
                            if (adjustedPath && adjustedPath.startsWith('Output.')) {
                              adjustedPath = adjustedPath.substring(7);
                            } else if (adjustedPath === 'Output') {
                              adjustedPath = '';
                            }
                            sendData(`nodes.${k}.outputFields${adjustedPath ? '.' + adjustedPath : ''}`);
                          }
                        }}
                      />
                    </InspectorWrapperWithIcon>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </TabPanel>
      </div>
    );
  };
  
  export default CustomSelectWidget;
  
/** React context for Override mode array Add/Remove so handlers work even when RJSF formContext is not passed through. */
const OverrideArrayActionsContext = createContext(null);

/** Module-level ref for Override mode array handlers so Add works even if context doesn't flow (e.g. RJSF/material-ui tree). SingleFieldEditor sets this when mounted with bodyKey; ArrayFieldTemplate calls it on Add click. */
const overrideArrayActionsRef = { current: null };

/** Wraps Form with OverrideArrayActionsContext and sets module ref so ArrayFieldTemplate Add/Remove work in override mode (e.g. FieldsRender with bodyKeyOnly). */
function OverrideArrayActionsBridge({ value, children }) {
  useEffect(() => {
    if (value) {
      overrideArrayActionsRef.current = value;
      return () => { overrideArrayActionsRef.current = null; };
    }
  }, [value]);
  if (!value) return children;
  return (
    <OverrideArrayActionsContext.Provider value={value}>
      {children}
    </OverrideArrayActionsContext.Provider>
  );
}

/** When formContext.bodyKey is set (Override mode single-field edit), only render that one property so the form matches Manual mode structure and RJSF Add/Remove work. */
function SingleFieldObjectFieldTemplate(props) {
  const { formContext = {}, properties, title, description, TitleField, DescriptionField, idSchema, required, schema, uiSchema, formData, onAddClick, disabled, readonly } = props;
  const bodyKey = formContext.bodyKey;
  const filteredProperties = bodyKey != null
    ? properties.filter((p) => p.name === bodyKey)
    : properties;
  return (
    <div id={idSchema?.$id}>
      {(uiSchema?.['ui:title'] || title) && TitleField && (
        <TitleField id={`${idSchema?.$id}__title`} title={title || uiSchema?.['ui:title']} required={required} formContext={formContext} />
      )}
      {description && DescriptionField && (
        <DescriptionField id={`${idSchema?.$id}__description`} description={description} formContext={formContext} />
      )}
      {filteredProperties.map((prop) => prop.content)}
      {bodyKey == null && schema?.additionalProperties !== false && onAddClick && (
        <Button type="button" size="small" onClick={onAddClick(schema)} disabled={disabled || readonly} style={{ marginTop: 8 }}>
          + Add property
        </Button>
      )}
    </div>
  );
}

const ArrayFieldTemplate = (props)=> {
  const theme = useTheme();
  const overrideActions = useContext(OverrideArrayActionsContext);
  const buttonRef = useRef(null);
  const buttonRef2 = useRef(null);
  const [counter, setCounter] = useState(0);

  /* function clickHandler(event) {
    setCounter((prev) => prev + 1);
  } */
  /* useEffect(() => {
    if (typeof props.formData[0] === 'object' && props.formData[0] !== null ) {
    }
    else {
    buttonRef.current.addEventListener('click', clickHandler);
    buttonRef.current.click();
    }
    return () => { 
    
    };
  }, []); */
  
    return (
        <div>
        <Typography>{props.schema.title}</Typography>
        <Typography>{props.schema.description}</Typography>
        {props.items &&
          props.items.map(element => (
            <div key={element.key} >
              <div style={{fontSize: '14px'}}>{element.children}</div>
              <div style={{float: "right"}}>
              {element.hasMoveDown && (
                  <Tooltip title="Move down" placement="top">
                    <span>
                      <IconButton style={{cursor: "pointer"}}
                        onClick={element.onReorderClick(element.index, element.index + 1)}>
                        <ArrowDownwardRoundedIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
              )}
              {element.hasMoveUp && (
                  <Tooltip title="Move up" placement="top">
                    <span>
                      <IconButton style={{cursor: "pointer"}}
                        onClick={element.onReorderClick(element.index, element.index - 1)}>
                        <ArrowUpwardRoundedIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
              )}
              <Tooltip title="Remove this item" placement="top">
                <span>
                  <IconButton id="deletebutton" ref={buttonRef2} style={{cursor: "pointer", marginBottom: '8px'}}
                    onClick={() => {
                      if (typeof overrideActions?.onArrayItemRemove === 'function') {
                        overrideActions.onArrayItemRemove(element.index);
                      } else {
                        const ctx = props.formContext || {};
                        if (typeof ctx.onArrayItemRemove === 'function') {
                          ctx.onArrayItemRemove(element.index);
                        } else if (typeof ctx.updateBodyArray === 'function') {
                          // Manual mode body array: persist remove so read-only view updates (RJSF onChange may not fire)
                          const key = (props.idSchema?.$id || '').split('_').pop();
                          const current = Array.isArray(props.formData) ? props.formData : [];
                          const next = current.filter((_, i) => i !== element.index);
                          ctx.updateBodyArray(key, next);
                        }
                      }
                      element.onDropIndexClick(element.index)();
                    }}>
                    <ClearRoundedIcon />
                  </IconButton>
                </span>
              </Tooltip>
              
              
              </div>
              <hr style={{marginTop: '8px', marginBottom: '8px', width: "100%", borderColor: theme.palette.divider}} />
            </div>
      
          ))}
  
        {props.canAdd && (
          <div className="row">
            <p className="col-xs-3 col-xs-offset-9 array-item-add text-right">
              <Button ref={buttonRef} id="addbutton" type="button" variant="contained" disabled={false} style={{textTransform: "none", color: theme.palette.getContrastText(theme.palette.primary.main), backgroundColor: theme.palette.primary.main, float: "right", padding: '4px 8px 4px 8px', marginBottom: '8px'}} onClick={(e) => {
              const useRjsf = props.formContext?.useRjsfAddRemove === true;
              if (useRjsf) {
                if (typeof props.onAddClick === 'function') props.onAddClick(e);
                return;
              }
              const addHandler = overrideActions?.onArrayItemAdd ?? overrideArrayActionsRef.current?.onArrayItemAdd ?? (props.formContext || {}).onArrayItemAdd;
              if (typeof addHandler === 'function') {
                e.preventDefault();
                e.stopPropagation();
                addHandler();
              } else if (typeof props.onAddClick === 'function') {
                props.onAddClick(e);
              }
            }}>
              + Add to {props.schema.title}
            </Button>
            </p>
          </div>
        )}
      </div>
    );
    
  }
 
   

export function WorkflowWidget( props, id, setFields, initVal, schemaObj, sendData = null) {
  const theme = useTheme();
  const [formloading, setFormLoading] = useState(true)
  const [schema, setSchema] = useState(schemaObj);
  const [value, setValue] = useState(props.value);  
  const [selectionStart, setSelectionStart] = useState();
  const [nodes, setNodes] = useState([]);
  const [open, setOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ left: 0, top: 0 });
  const fieldRef = useRef(null);
  const parentTree = useSelector(selectParentTree);
  const nodeId = useSelector(selectCurrentElement);
  const nodeData = useSelector(selectElementById(nodeId))
  const portalRef = useRef(null);
const lastAnchorRectRef = useRef(null);
const lockBottomRef = useRef(false);
  
  //const workflowData = useSelector(selectWorkflowTemplateNodes)
  const parents = parentTree[nodeId];

  const selfFieldName =
    props.formContext?.fieldName ||
    props.name ||
    (typeof props.id === 'string' && props.id !== 'root'
      ? props.id.replace(/^root_?/, '').split('_').filter(Boolean).pop()
      : undefined);
  const unmetDeps = props.schema?.dynamic
    ? getUnmetDynamicParams(
        { name: selfFieldName, schema: props.schema },
        nodeData?.data?.fields || []
      )
    : [];
  const depsBlocked = unmetDeps.length > 0;
  const depsHint = depsBlocked
    ? `Select ${unmetDeps.map((d) => d.label).join(', ')} first`
    : '';
  
 
  const [CM, setCM] = useState(null)

  const widgetRe =  /\${(([^}][^}]?|[^}]}?)*)}/;
  const widgetRe2 = /[\s\S]+/;
  const classes = useStyles()
  const prettyOptions = {
      mode: { name: 'workload-mode', type: 'text/html' },
      lineNumbers: false,
      fullScreen: false,
      scrollbarStyle: null,
      lineWrapping: false,
      theme: 'neat',
      extraKeys: {Tab: false, "Shift-Tab": false},
      //cursorBlinkRate: 0, // Disable cursor blinking
     // readOnly: props.schema.dynamic ? true : false
  }

  const tryOpenDynamicPicker = (anchorRect) => {
    if (depsBlocked) return false;
    window.dispatchEvent(new Event('wf-close-all-dropdowns'));
    window.dispatchEvent(new CustomEvent('wf-open-dropdown', { detail: dropdownInstanceIdRef.current }));
    const pos = computeInitialDropdownPosition(anchorRect, 350, 420);
    setDropdownPosition(pos);
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const estHeight = 420;
    lockBottomRef.current = (vh - anchorRect.top) <= estHeight;
    setTimeout(() => {
      setOpen(true);
      triggerReclampBurst();
    }, 0);
    return true;
  };
  
 

  const handleClickAway = (event) => {
    // Suppress click-away if a controlled internal interaction (e.g., tab change) just occurred
    if (typeof window !== 'undefined' && window.wfSuppressClickAwayUntil && Date.now() < window.wfSuppressClickAwayUntil) {
      return;
    }
    
    // CRITICAL: Don't close if clicking inside the dropdown portal
    // ClickAwayListener passes a MouseEvent or TouchEvent, so we need to check the actual DOM target
    if (open && portalRef.current) {
      // Get the actual DOM element from the event
      // ClickAwayListener passes the native event, so event.target should be the DOM element
      const target = event?.target;
      
      if (target) {
        // Check if target is inside portal
        if (portalRef.current.contains(target)) {
          return;
        }
        
        // Also check if any parent of target is the portal
        let current = target.parentElement;
        let depth = 0;
        while (current && depth < 10) {
          if (current === portalRef.current) {
            return;
          }
          current = current.parentElement;
          depth++;
        }
      }
      
      // Fallback: check if portal is in the event path
      if (event?.composedPath && typeof event.composedPath === 'function') {
        try {
          const path = event.composedPath();
          if (path && path.some(node => {
            if (!node || !node.nodeType) return false;
            return node === portalRef.current || portalRef.current.contains(node);
          })) {
            return;
          }
        } catch (e) {
          // composedPath might not be available
        }
      }
    }
    
    // Use latestValueRef if available (from debouncedOnChange), otherwise use value
    const valueToCommit = latestValueRef.current !== undefined ? latestValueRef.current : value;
    props.onChange(valueToCommit);
    setOpen(false);
  }

  const calculateDropdownPosition = () => {
    if (fieldRef.current) {
      const rect = fieldRef.current.getBoundingClientRect();
      const leftPosition = Math.max(20, rect.left - 360);
      const topPosition = rect.top;
      setDropdownPosition({
        left: leftPosition,
        top: topPosition
      });
    }
  }

  // Close other dropdowns when one opens
  useEffect(() => {
      const onGlobalClose = () => {
        // Don't close if suppression flag is set (accordion was just clicked)
        // BUT allow close if flag was explicitly cleared (close button was clicked)
        if (typeof window !== 'undefined' && window.wfSuppressClickAwayUntil && Date.now() < window.wfSuppressClickAwayUntil && window.wfSuppressClickAwayUntil !== 0) {
          return;
        }
        // Don't close if portal is open and click was inside it
        // BUT check if the click was on the close button (which should close)
        if (portalRef.current) {
          const activeEl = document.activeElement;
          // Check if active element is the close button or inside a close button
          const isCloseButton = activeEl && (
            activeEl.closest('[data-wf-close-button="true"]') ||
            activeEl.getAttribute('data-wf-close-button') === 'true'
          );
          if (activeEl && portalRef.current.contains(activeEl) && !isCloseButton) {
            return;
          }
        }
        setOpen(false);
      };
      window.addEventListener('wf-close-all-dropdowns', onGlobalClose);
      return () => window.removeEventListener('wf-close-all-dropdowns', onGlobalClose);
  }, [])


  const [cursorpos, setCursorPos] = useState()
  const onChangeTimeoutRef = useRef(null)
  const editorRef = useRef(null)
  const cursorPositionRef = useRef(null)
  const dropdownInstanceIdRef = useRef(Math.random().toString(36).slice(2))

  const triggerReclampBurst = () => {
  // Burst a few reclamps across ~300ms to catch animations
  let count = 0;
  const tick = () => {
    window.dispatchEvent(new Event('wf-reclamp-dropdown'));
    count += 1;
    if (count < 8) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
  };

  const computeInitialDropdownPosition = (anchorRect, dropdownWidth = 350, estMenuHeight = 420) => {
    const viewportW = window.innerWidth;
    const viewportH = window.innerHeight;
    const margin = 8;

    // Prefer left of the anchor
    let left = anchorRect.left - dropdownWidth - 20;
    if (left < margin) {
      // Try right side
      left = anchorRect.right + 20;
      if (left + dropdownWidth > viewportW - margin) {
        // Center as fallback
        left = Math.max(margin, (viewportW - dropdownWidth) / 2);
      }
    }

    // Vertical: if not enough space below to show a reasonable portion, flip above
    const spaceBelow = viewportH - anchorRect.bottom - margin;
    const spaceAbove = anchorRect.top - margin;
    let top;
    const minOpenHeight = Math.min(estMenuHeight, viewportH - margin * 2);
    if (spaceBelow < Math.min(280, minOpenHeight) && spaceAbove > spaceBelow) {
      // Open above with as much height as possible
      top = Math.max(margin, anchorRect.top - minOpenHeight);
    } else {
      // Open aligned to anchor top but keep within viewport
      top = Math.max(margin, Math.min(anchorRect.top, viewportH - margin - 120));
    }

    return { left, top };
  };
  
  // Normalize value to string for CodeMirror/text ops (value can be object, array, or undefined)
  const valueAsString = (v) => {
    if (v == null) return '';
    if (typeof v === 'string') return v;
    if (typeof v === 'object' && v !== null && !Array.isArray(v) && 'value' in v) return String(v.value ?? '');
    return String(v);
  };

  const updateValue = (ref) => {
      const str = valueAsString(value);
      var rows = str ? str.replace(/\r\n/g, '\n').split('\n') : [''];
      const index = cursorpos ? cursorpos.ch : 0;
      const line = cursorpos ? cursorpos.line : 0;
      var selection = rows[line];
      if (selection == null) selection = '';
      const left = selection.slice(0, index);
      const right = selection.slice(index);
      var newval = left+ref+right
      
      rows.splice(line,1,newval)
      var new_rows = rows.join("\n")
      
      setValue(new_rows)
  }

  // Store the latest value but don't call onChange immediately
  const latestValueRef = useRef(value);
  
  const debouncedOnChange = (value) => {
      latestValueRef.current = value;
      // Don't call props.onChange immediately - wait for blur or unmount
  }
  
  // Call onChange when component unmounts or field loses focus
  useEffect(() => {
      return () => {
          // Component unmounting - save the latest value
          if (latestValueRef.current !== undefined) {
              props.onChange(latestValueRef.current);
          }
      };
  }, []);

  useEffect(() => {
    if (!open) return;
    const el = portalRef.current;
    if (!el) return;
  
    const margin = 16;
  
    // If we intend to bottom-anchor, do an immediate two-pass snap so the
    // bottom edge is guaranteed inside the viewport on first render.
    if (lockBottomRef.current) {
      requestAnimationFrame(() => {
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const vw = window.innerWidth || document.documentElement.clientWidth;
        // Enforce max height before measuring
        const maxUsable = Math.max(0, vh - margin * 2);
        const desired = Math.min(el.scrollHeight, maxUsable);
        el.style.maxHeight = `${desired}px`;
        const rectNow = el.getBoundingClientRect();
        const targetTop = Math.max(margin, vh - margin - rectNow.height);
        // Align to the left edge of the right-side panel (34vw width ⇒ left edge at 66vw)
        const panelLeft = vw * 0.66;
        const gap = 8;
        const targetLeft = Math.max(margin, Math.min(panelLeft - gap - rectNow.width, vw - margin - rectNow.width));
        setDropdownPosition(prev => ({ ...prev, top: targetTop, left: targetLeft }));
      });
    }
  
    const clamp = () => {
      // Always use full window viewport dimensions (not any scroll container)
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const vw = window.innerWidth || document.documentElement.clientWidth;

      // Measure and enforce a strict max height so the dropdown never exceeds viewport
      const maxUsableHeight = Math.max(0, vh - margin * 2);
      const desiredHeight = Math.min(el.scrollHeight, maxUsableHeight);
      // Apply the maxHeight directly to the portal container so content scrolls inside
      if (el.style.maxHeight !== `${desiredHeight}px`) {
        el.style.maxHeight = `${desiredHeight}px`;
      }

      // Re-measure after potential style change
      const rect = el.getBoundingClientRect();
      const actualHeight = rect.height;
      const actualWidth = rect.width;

      const viewportBottom = vh - margin;
  
      setDropdownPosition(prev => {
        // Position from bottom if we would overflow OR if explicitly bottom-locked
        const projectedBottom = prev.top + actualHeight;
        let newTop = prev.top;
        if (projectedBottom > viewportBottom || lockBottomRef.current) {
          newTop = Math.max(margin, viewportBottom - actualHeight);
        }

        // Ensure we never go above the top margin
        newTop = Math.max(margin, newTop);

        // Align to 34vw side panel edge (panel left at 66vw) and clamp within viewport
        const panelLeft = vw * 0.66;
        const gap = 8;
        let newLeft = Math.max(margin, Math.min(panelLeft - gap - actualWidth, vw - margin - actualWidth));
        if (newLeft + actualWidth > vw - margin) {
          newLeft = Math.max(margin, vw - margin - actualWidth);
        }
        newLeft = Math.max(margin, newLeft);

        if (newTop === prev.top && newLeft === prev.left) return prev;
        return { top: newTop, left: newLeft };
      });
    };
    
    // Shared burst ID - declare before use in observers
    let rafIdBurst = null;
    const startClampBurst = (durationMs = 1500) => {
      const end = performance.now() + durationMs;
      const loop = () => {
        clamp();
        if (performance.now() < end) rafIdBurst = requestAnimationFrame(loop);
      };
      if (rafIdBurst) cancelAnimationFrame(rafIdBurst);
      rafIdBurst = requestAnimationFrame(loop);
    };
  
    // First paint after open
    requestAnimationFrame(clamp);
    // Also clamp at transition end (e.g., Accordion animations)
    const onTransitionEnd = () => {
      requestAnimationFrame(clamp);
      startClampBurst(600);
    };
    el.addEventListener('transitionend', onTransitionEnd, true);
  
    // Observe size and subtree changes - trigger aggressive reclamp
    const ro = new ResizeObserver(() => {
      requestAnimationFrame(clamp);
      startClampBurst(1000);
    });
    ro.observe(el);
  
    const mo = new MutationObserver(() => {
      requestAnimationFrame(clamp);
      // Delay slightly to catch accordion content expansion
      setTimeout(() => {
        startClampBurst(800);
      }, 50);
    });
    mo.observe(el, { attributes: true, childList: true, subtree: true });
  
    // Re-clamp on window resize and manual event
    const onWin = () => requestAnimationFrame(clamp);
    const onReclamp = () => requestAnimationFrame(clamp);
    window.addEventListener('resize', onWin);
    window.addEventListener('scroll', onWin, true);
    window.addEventListener('wf-reclamp-dropdown', onReclamp);
  
    // 🔹 NEW: clamp on user interactions that usually expand accordions
    const onUserAction = () => {
      // One rAF to get past the click frame, then a short delay for CSS transitions.
    requestAnimationFrame(() => setTimeout(() => { clamp(); startClampBurst(1500); }, 120));
    };
    // Capture phase so we catch it even if inner components stop propagation
    el.addEventListener('click', onUserAction, true);
    el.addEventListener('keydown', onUserAction, true);
    return () => {
      ro.disconnect();
      mo.disconnect();
      window.removeEventListener('resize', onWin);
      window.removeEventListener('wf-reclamp-dropdown', onReclamp);
      window.removeEventListener('scroll', onWin, true);
      el.removeEventListener('click', onUserAction, true);
      el.removeEventListener('keydown', onUserAction, true);
      el.removeEventListener('transitionend', onTransitionEnd, true);
      if (rafIdBurst) cancelAnimationFrame(rafIdBurst);
    };
  }, [open]);

  // Ensure only one dropdown is open globally
  useEffect(() => {
    const onAnyOpen = (e) => {
      if (!e || !e.detail) return;
      if (e.detail !== dropdownInstanceIdRef.current) {
        setOpen(false);
      }
    };
    window.addEventListener('wf-open-dropdown', onAnyOpen);
    return () => window.removeEventListener('wf-open-dropdown', onAnyOpen);
  }, []);

  
  

  

  const handleChange2 = (editor, data, value) => {
    //console.log('pre value is: ',value)
    setValue(value)
    //console.log('post value is: ',value )
    const cursor = editor.getSearchCursor(props.schema.dynamic ? widgetRe2 : widgetRe, 0, { multiline: 'disable' })
   
    while (cursor.findNext()) {
        
        const stringMatch = editor.getRange(cursor.from(), cursor.to()).match(props.schema.dynamic ? widgetRe2 : widgetRe)[1]
        const doc = editor.getDoc()
       
        var currNode = document.createElement('span')

        try {
            const refInfo = props.schema.dynamic ? null : stringMatch.split('.') //format nodes.{nodeID}.outputFields.{refString...}
            if (props.schema.dynamic){

                var fromObj = cursor.from()
                var toObj = cursor.to()
              
            // If value is an object with label, display the label; otherwise display the value
            const displayLabel = (value && typeof value === 'object' && value !== null && value.label) ? value.label : (value || '');
            ReactDOM.render(<DynamicChip deleteClick={() => doc.replaceRange("", fromObj, toObj)} icon={nodeData.data.icon}  label={displayLabel}  />, currNode)
                
            } else {
                
            const refNodeID = refInfo[1]
            const testDataRefString = refInfo.slice(3).join('.')
           // console.log('testdata ref string: ', testDataRefString)
            const refNode = parents[refNodeID]
            const matchData = Object.byString(refNode.data.testData, testDataRefString)
            //console.log('refNodeID is: ', refNodeID)
            //console.log('opened node ID is: ', refInfo)
            var fromObj = cursor.from()
            var toObj = cursor.to()
          // console.log('refNodeID is: ', parents.indexOf(refNodeID))
           
            ReactDOM.render(<WorkflowChip deleteClick={() => doc.replaceRange("", fromObj, toObj)} icon={refNode.data.icon} step={null} label={refInfo[refInfo.length - 1]} cvalue={(!Array.isArray(matchData) && !(typeof matchData === 'object')) ? matchData : JSON.stringify(matchData)} />, currNode)
                }
            }
        catch (e) {
           // console.log('failed rendering thing')
           // console.log(e)
         
            ReactDOM.render(<WorkflowChip icon={null} step={'replacelabel'} label={"Unknown Reference"} cvalue={"N/A"} />, currNode)
        }

        editor.markText(cursor.from(), cursor.to(), { replacedWith: currNode })
    }
   
}

const handleDynamicValueChange = (incoming) => {
  // Handle null/undefined/empty - clear the field
  if (incoming === null || incoming === undefined || incoming === '') {
    // Clear CodeMirror editor
    if (editorRef.current) {
      const editor = editorRef.current;
      const doc = editor.getDoc();
      doc.setValue('');
    }
    setValue('');
    latestValueRef.current = '';
    props.onChange('');
    setOpen(false);
    return;
  }
  
  // If incoming is an object with label and value, store it as-is
  if (incoming && typeof incoming === 'object' && incoming !== null && (incoming.label !== undefined || incoming.value !== undefined)) {
    let valueToStore = incoming.value ?? '';
    // For dynamic fields, the value should be wrapped in ${} if it's a path reference
    // If the value is a path reference (starts with 'nodes.') and doesn't already have ${}, wrap it
    if (typeof valueToStore === 'string' && valueToStore.startsWith('nodes.') && !valueToStore.startsWith('${')) {
      valueToStore = '${' + valueToStore + '}';
    }
    const valueObj = { label: incoming.label ?? String(valueToStore ?? ''), value: valueToStore };
    // Update CodeMirror synchronously FIRST - this is the source of truth
    if (editorRef.current) {
      const editor = editorRef.current;
      const doc = editor.getDoc();
      const codeMirrorValue = typeof valueObj.value === 'string' ? valueObj.value : String(valueObj.value ?? '');
      doc.setValue(codeMirrorValue);
      // Blur to commit the value immediately
      editor.getInputField().blur();
      // Also update latestValueRef with the string value (what CodeMirror has)
      // This ensures handleSentData2 reads the correct value
      latestValueRef.current = codeMirrorValue;
    }
    setValue(valueObj);
    // Call onChange with the object for form state, but CodeMirror has the string
    props.onChange(valueObj);
    setOpen(false);
    return;
  }
  
  // Otherwise handle as before (string, boolean, etc.)
  let nextValue;
  if (typeof incoming !== 'string'){
      if (typeof incoming === 'boolean') {
          nextValue = incoming;
      } else {
          nextValue = incoming.toString();
      }
  } else {
      nextValue = incoming;
  }
  
  // Update CodeMirror synchronously for string/primitive values
  if (editorRef.current) {
    const editor = editorRef.current;
    const doc = editor.getDoc();
    const codeMirrorValue = typeof nextValue === 'string' ? nextValue : String(nextValue ?? '');
    doc.setValue(codeMirrorValue);
    // Blur to commit the value
    editor.getInputField().blur();
  }
  
  setValue(nextValue);
  latestValueRef.current = nextValue;
  // Commit immediately so dependent dynamic dropdowns read fresh params
  props.onChange(nextValue);
  setOpen(false);
}

const [booleanButton, setBooleanButton] = useState(props.value)

  useEffect(() => {
    return () => {
      if (typeof window !== 'undefined' && window.wfCodeMirrorRegistry && props.id) {
        delete window.wfCodeMirrorRegistry[props.id];
      }
    };
  }, [props.id]);

  // When portal is open, handle closing manually instead of using ClickAwayListener
  useEffect(() => {
    if (!open) return;
    
    const handleDocumentClick = (e) => {
      const target = e.target;
      
      // CRITICAL: Check if click is inside portal FIRST - this is the most reliable check
      // We check this before suppression flag because portal containment is definitive
      if (portalRef.current) {
        // First, try direct containment check (fastest)
        if (portalRef.current.contains(target)) {
          return;
        }
        
        // Also check event path/composedPath for portal (most reliable, works even with portals)
        let eventPath = [];
        if (e.composedPath && typeof e.composedPath === 'function') {
          try {
            eventPath = e.composedPath();
          } catch (err) {
            // composedPath might fail
          }
        }
        
        // Check if any element in the path is inside the portal
        if (eventPath.some(node => {
          if (!node || !node.nodeType) return false;
          return portalRef.current && portalRef.current.contains(node);
        })) {
          return;
        }
        
        // Fallback: traverse up the DOM tree manually
        let current = target;
        let depth = 0;
        while (current && depth < 30) {
          if (portalRef.current.contains(current)) {
            return;
          }
          current = current.parentElement || current.parentNode;
          depth++;
        }
      }
      
      // Check suppression flag SECOND (in case accordion handler set it)
      if (typeof window !== 'undefined' && window.wfSuppressClickAwayUntil && Date.now() < window.wfSuppressClickAwayUntil) {
        return;
      }
      
      // Don't close if clicking on the field that opened it (but allow closing if clicking the button again)
      if (fieldRef.current && fieldRef.current.contains(target)) {
        // Check if it's the "+" button - if so, allow it to toggle
        const isAddButton = target.closest && target.closest('button[aria-label*="Add"], button[aria-label*="data"]');
        if (!isAddButton) {
          return;
        }
      }
      
      // Close the dropdown
      const valueToCommit = latestValueRef.current !== undefined ? latestValueRef.current : value;
      props.onChange(valueToCommit);
      setOpen(false);
    };
    
    // Use capture phase but check portal containment IMMEDIATELY before doing anything else
    // This ensures clicks inside portal are caught before any other logic
    const handleClickCapture = (e) => {
      const target = e.target;
      
      // CRITICAL: Check if click is on close button FIRST - this should always close
      if (target && (target.closest('[data-wf-close-button="true"]') || target.getAttribute('data-wf-close-button') === 'true')) {
        // Close button was clicked - clear suppression flag and close
        if (typeof window !== 'undefined') {
          window.wfSuppressClickAwayUntil = 0;
        }
        const valueToCommit = latestValueRef.current !== undefined ? latestValueRef.current : value;
        props.onChange(valueToCommit);
        setOpen(false);
        return;
      }
      
      // CRITICAL: Traverse up DOM tree FIRST to check for accordion/portal data attributes
      // This is the most reliable method
      let current = target;
      let depth = 0;
      while (current && depth < 50) {
        // Check for accordion FIRST - if found, definitely don't close
        if (current.getAttribute && current.getAttribute('data-wf-accordion') === 'true') {
          return; // Click is on accordion - don't close dropdown
        }
        // Check for portal
        if (current.getAttribute && current.getAttribute('data-wf-dropdown-portal') === 'true') {
          return; // Click is inside portal - don't close dropdown
        }
        current = current.parentElement || current.parentNode;
        depth++;
      }
      
      // Also check portal ref containment
      if (portalRef.current && portalRef.current.contains(target)) {
        return;
      }
      
      // Check event path
      if (e.composedPath && typeof e.composedPath === 'function') {
        try {
          const path = e.composedPath();
          for (const node of path) {
            if (!node || !node.nodeType) continue;
            if (node.getAttribute && node.getAttribute('data-wf-accordion') === 'true') {
              return;
            }
            if (node.getAttribute && node.getAttribute('data-wf-dropdown-portal') === 'true') {
              return;
            }
            if (portalRef.current && portalRef.current.contains(node)) {
              return;
            }
          }
        } catch (err) {
          // Ignore
        }
      }
      
      // If we get here, click is outside portal
      // Check suppression flag before closing
      if (typeof window !== 'undefined' && window.wfSuppressClickAwayUntil && Date.now() < window.wfSuppressClickAwayUntil) {
        return;
      }
      
      // Use setTimeout to allow other handlers to set suppression flag
      setTimeout(() => {
        if (typeof window !== 'undefined' && window.wfSuppressClickAwayUntil && Date.now() < window.wfSuppressClickAwayUntil) {
          return;
        }
        handleDocumentClick(e);
      }, 0);
    };
    
    document.addEventListener('mousedown', handleClickCapture, true);
    document.addEventListener('touchstart', handleClickCapture, true);
    
    return () => {
      document.removeEventListener('mousedown', handleClickCapture, true);
      document.removeEventListener('touchstart', handleClickCapture, true);
    };
  }, [open, value, props]);

  return (
      <ClickAwayListener key={'cc'+id} onClickAway={open ? () => {} : handleClickAway}>
          <div key={'base'+id} style={{ padding: '2px 8px 2px 8px' }} 
               onFocus={(e) => {
                 if (e.currentTarget === e.target) {
                     //    console.log('focused self');
                 } else {
                     // Only auto-open for dynamic or enum fields (and only if parent deps are met)
                     if (props.schema && (props.schema.dynamic || props.schema.enum) && !depsBlocked) {
                       const anchor = fieldRef.current ? fieldRef.current.getBoundingClientRect() : e.currentTarget.getBoundingClientRect();
                       tryOpenDynamicPicker(anchor);
                     }
                 }
               }}>
              <Typography key={props.id} style={{fontWeight: 'bold', color: theme.palette.text.primary, opacity: depsBlocked ? 0.7 : 1}}>{props.schema.title}</Typography>
              {depsBlocked ? (
                <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginBottom: 4 }}>
                  {depsHint}
                </Typography>
              ) : null}
              <div  
                  key={"codemirror_wrap" + id} 
                  id='codemirror-wrapper' 
                  data-wf-field-id={props.id || ''}
                  className={`${classes.codemirror} ${props.schema.dynamic ? classes.codemirrorDynamic : ''}`}
                  style={{
                    position: 'relative',
                    ...(props.schema.dynamic ? { cursor: depsBlocked ? 'not-allowed' : 'pointer' } : {}),
                    ...(depsBlocked ? { opacity: 0.55, pointerEvents: 'none' } : {}),
                  }}
                  ref={fieldRef}
              >
              {props.schema.type === 'boolean' ? 
             /*   <TextField
               label={props.schema.title || ''}
               // Convert the boolean to a string for the select value.
               value={value === true ? 'true' : value === false ? 'false' : ''}
               onChange={(e) => {
                 // Convert back to a boolean before calling onChange.
                 const boolVal = e.target.value === 'true';
                 handleChange2(null, null, boolVal);
                 props.onChange(boolVal);
               }}
               variant="outlined"
               fullWidth
            /> */
            <ButtonGroup disableElevation style={{marginLeft: '4px'}}>
            <Button color="primary" style={{textTransform: 'none'}} onClick={() => {setBooleanButton(true); props.onChange(true)}}  variant={booleanButton === true ? "contained" : "outlined"}>{<Typography>Yes</Typography>}</Button>
            <Button color="primary" style={{textTransform: 'none'}} onClick={() => {setBooleanButton(false); props.onChange(false)}}  variant={booleanButton === false ? "contained" : "outlined"}><Typography>No</Typography></Button>
          </ButtonGroup>
              : 
                  <CodeMirror
                      key={props.id}
                      id={props.id}
                      defaultValue={valueAsString(value)}
                      value={valueAsString(value)}
                      options={prettyOptions}
                      autoCursor={false}
                      onCursor={(editor) => { 
                          const cursor = editor.getCursor();
                          setCursorPos(cursor);
                          cursorPositionRef.current = cursor;
                      } }
                      style={props.schema.dynamic ? { cursor: 'pointer' } : {}}
                      onChange={(editor, data, value) => { 
                        handleChange2(editor, data, value); 
                        debouncedOnChange(value);
                        //props.onChange(value);
                      }}
                      onBlur={(editor) => {
                        // Commit current editor content so clearing the field and clicking Done persists
                        try {
                          const raw = (editor.getDoc().getValue() || '').trim();
                          props.onChange(raw === '' ? '' : raw);
                        } catch (_) {
                          if (latestValueRef.current !== undefined) {
                            props.onChange(latestValueRef.current);
                          }
                        }
                      }}
                      editorDidMount={(editor) => {
                        editorRef.current = editor;
                        handleChange2(editor, 1, value );
                        props.onChange(value);
                        if (typeof window !== 'undefined') {
                          if (!window.wfCodeMirrorRegistry) {
                            window.wfCodeMirrorRegistry = {};
                          }
                          if (props.id) {
                            window.wfCodeMirrorRegistry[props.id] = editor;
                          }
                        }
                        try {
                          const wrapper = editor.getWrapperElement && editor.getWrapperElement();
                          if (wrapper) {
                            wrapper.setAttribute('data-wf-field-id', props.id || '');
                          }
                        } catch (_) {}
                        setFormLoading(false);
                      }}
                     
                      
                  /> }
                  
                  {/* Add UnfoldMoreRoundedIcon for dynamic string fields */}
                  {props.schema.dynamic && props.schema.type === 'string' ? 
                    <Tooltip title={depsBlocked ? depsHint : ''} placement="top">
                      <span style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', zIndex: 6, pointerEvents: 'auto' }}>
                        <Button 
                          disabled={depsBlocked}
                          style={{ 
                            minWidth: '32px',
                            width: '32px',
                            height: '32px',
                            padding: '0',
                            backgroundColor: theme.palette.background.paper,
                            border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#ddd'}`,
                            borderRadius: '6px',
                            boxShadow: theme.palette.type === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: depsBlocked ? 0.5 : 1,
                          }} 
                          onClick={(e) => {
                            if (depsBlocked) return;
                            const buttonRect = e.currentTarget.getBoundingClientRect();
                            lastAnchorRectRef.current = buttonRect;
                            tryOpenDynamicPicker(buttonRect);
                          }}
                          size="small"
                        >
                          <UnfoldMoreRoundedIcon style={{ fontSize: '18px', color: theme.palette.text.primary }} />
                        </Button>
                      </span>
                    </Tooltip> : null }
                  
                  {/* Add AddRoundedIcon for non-dynamic string fields */}
                  {!props.schema.dynamic && props.schema.type === 'string' ? 
                    <Button 
                      style={{ 
                        position: 'absolute', 
                        right: '8px', 
                        top: '50%', 
                        transform: 'translateY(-50%)', 
                        zIndex: 6, 
                        minWidth: '32px',
                        width: '32px',
                        height: '32px',
                        padding: '0',
                        backgroundColor: theme.palette.background.paper,
                        border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : '#ddd'}`,
                        borderRadius: '6px',
                        boxShadow: theme.palette.type === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }} 
                      onClick={(e) => {
                        window.dispatchEvent(new Event('wf-close-all-dropdowns'));
                        window.dispatchEvent(new CustomEvent('wf-open-dropdown', { detail: dropdownInstanceIdRef.current }));
                        
                        // Calculate position relative to the button that was clicked
                        const buttonRect = e.currentTarget.getBoundingClientRect();
                        const pos = computeInitialDropdownPosition(buttonRect, 350, 420);
                        setDropdownPosition(pos);
                        const vh = window.innerHeight || document.documentElement.clientHeight;
                        const estHeight = 420;
                        lockBottomRef.current = (vh - buttonRect.top) <= estHeight;
                        
                        // Use setTimeout to ensure position is calculated before opening
                        setTimeout(() => {
                          setOpen(true);
                          triggerReclampBurst();
                        }, 0);
                      }}
                      size="small"
                    >
                      <AddRoundedIcon style={{ fontSize: '18px', color: theme.palette.text.primary }} />
                    </Button> : null }
                  
                  {open === true ? createPortal(
                    <div 
                      ref={portalRef}
                      data-wf-dropdown-portal="true"
                      onMouseDown={(e) => {
                        // Stop propagation to prevent ClickAwayListener from detecting clicks
                        e.stopPropagation();
                        if (typeof window !== 'undefined') {
                          window.wfSuppressClickAwayUntil = Date.now() + 500;
                        }
                      }}
                      onClick={(e) => {
                        // Stop propagation
                        e.stopPropagation();
                        if (typeof window !== 'undefined') {
                          window.wfSuppressClickAwayUntil = Date.now() + 500;
                        }
                      }}
                      style={{
                        position: 'fixed',
                        left: `${dropdownPosition.left}px`,
                        // If bottom-locked, anchor using bottom; otherwise use computed top
                        ...(lockBottomRef.current ? { bottom: '8px', top: 'auto' } : { top: `${dropdownPosition.top}px` }),
                        zIndex: 9999,
                        padding: '0px',              
                        width: '500px',
                        overflowX: 'hidden',
                        maxHeight: 'calc(100vh - 32px)',
                        overflowY: 'auto',
                        backgroundColor: theme.palette.background.paper,
                        // Outer container visual styles
                        boxShadow: theme.palette.type === 'dark' ? 'rgba(0, 0, 0, 0.5) 0px 10px 30px 0px' : 'rgba(0, 0, 0, 0.2) 0px 10px 30px 0px',
                        borderRadius: '0.5rem',
                        border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : 'rgb(215, 211, 201)'}`,
                        overflow: 'hidden',
                        }}>
                      
                      <React.Fragment>
                        {props.schema.enum ? (
                          <CustomSelectWidget setFields={setFields} open={true} props={{...props, usePortalLayout: true}} ky={id + '-dd'} parents={parents}
                           currentNode={nodeId} styleClass={classes} sendData={ref => {
                             if (typeof ref === 'string' && ref.includes("nodes")) {
                               handleDynamicValueChange('${' + ref + '}');
                             } else {
                               handleDynamicValueChange(ref);
                             }
                           }}
                           />
                        ) : props.schema.dynamic ? (
                          <DynamicDropdownAccordion setFields={setFields} open={true} props={{...props, usePortalLayout: true}} ky={id + '-dd'} 
                          parents={parents} currentNode={nodeId} styleClass={classes}
                          sendData={ref => { 
                            if (typeof ref === 'object' && ref !== null && (ref.label !== undefined || ref.value !== undefined)) {
                              handleDynamicValueChange(ref);
                            } else if (typeof ref === 'string' && ref.includes("nodes")) {
                              handleDynamicValueChange('${' + ref + '}');
                            } else {
                              handleDynamicValueChange(ref);
                            }
                          }} fieldLabel={props.formContext?.fieldTitle || props.schema.title} />
                        ) : nodeData.type === 'trigger' || props.schema.type === 'boolean' ? null : (
                          <DropdownAccordion props={{...props, usePortalLayout: true}} ky={id + '-dd'} parents={parents} currentNode={nodeId} fieldLabel={props.formContext?.fieldTitle || props.schema.title} styleClass={classes}
                           sendData={ref => {
                              updateValue('${' + ref + '}' ) }} />
                        )}
                      </React.Fragment>
                    </div>,
                    document.body
                  ) : null}
              </div>
      
          </div>
      
      </ClickAwayListener> 
      
  )
}


// muiTheme moved to FieldsRender to inherit from global theme

function DropdownAccordion({parents, props, ky, currentNode, sendData = null, styleClass, fieldLabel}) {
    const theme = useTheme();
    const [expanded, setExpanded] = useState(false)
    const dispatch = useDispatch();
    const classes = useStyles();
    const width = window.innerWidth;
    let breakpoint = ''

if (width < 450) {
    breakpoint = 'small'
} else if (width < 720 && width > 449) {
    breakpoint = 'medium'
} else if (width > 721) {
    breakpoint = 'large'
}
    const inPortal = props?.usePortalLayout;
     const portalSafeStyle = { position: 'static', boxShadow: theme.palette.type === 'dark' ? 'rgba(0, 0, 0, 0.5) 0px 10px 30px 0px' : 'rgba(0, 0, 0, 0.2) 0px 10px 30px 0px', width: 'auto', paddingBottom: '4px', borderRadius: '8px', border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : 'rgb(215, 211, 201)'}` };
    return (
        <div
        className={inPortal ? undefined : classes.dropdown}
        style={inPortal ? portalSafeStyle : undefined}
        >
        {/* Sticky header area */}
        <div style={{ position: 'sticky', top: 0, zIndex: 10001, backgroundColor: theme.palette.background.paper, background: theme.palette.background.paper, borderBottom: `1px solid ${theme.palette.divider}`, marginBottom: 0 }}>
           {/* Close button */}
        <div 
        data-wf-close-button="true"
        style={{
            position: 'absolute',
            top: '12px',
            right: '12px',
              zIndex: 10002,
            cursor: 'pointer',
            width: '28px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            fontSize: '16px',
            fontWeight: 'bold',
              border: `2px solid ${theme.palette.background.paper}`,
              boxShadow: theme.palette.type === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.2)',
              //backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary
        }}
        onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            // Clear suppression flag to ensure close works
            if (typeof window !== 'undefined') {
                window.wfSuppressClickAwayUntil = 0;
            }
            // Dispatch close event
            window.dispatchEvent(new Event('wf-close-all-dropdowns'));
        }}
        onMouseDown={(e) => {
            e.stopPropagation();
            e.preventDefault();
            // Clear suppression flag in capture phase too
            if (typeof window !== 'undefined') {
                window.wfSuppressClickAwayUntil = 0;
            }
        }}
        onMouseEnter={(e) => {
              e.target.style.color = theme.palette.primary.main;
        }}
        onMouseLeave={(e) => {
              e.target.style.color = theme.palette.text.primary;
        }}
        >
            <CloseRoundedIcon style={{ fontSize: '18px' }} />
        </div>
          <Typography key={ky} style={{ fontSize: 14, fontWeight: 900, marginLeft: 25, paddingTop: 25, paddingBottom: 20, backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary}}>Insert data for {fieldLabel} <span style={{ fontSize: 12, fontWeight: 400, color: theme.palette.text.secondary, padding: 4, border: `1px solid ${theme.palette.divider}`, borderRadius: '8px'}}><Typography variant="caption"  gutterBottom>Dynamic</Typography></span></Typography>
          <Divider style={{ marginBottom: 0 }} />
        </div>
        <div style={{ paddingTop: 0 }}>
            {parents ? Object.entries(parents).map(([k, v], i) => {
               
                return (
                    <div key={k + 'dvvv'}>

                        <Accordion 
                            elevation={0}
                            expanded={expanded === k} 
                            onChange={(event, isExpanded) => {
                                // Stop propagation to prevent ClickAwayListener from closing dropdown
                                if (event) {
                                  event.stopPropagation();
                                  if (event.nativeEvent) {
                                    event.nativeEvent.stopImmediatePropagation();
                                  }
                                }
                                // Suppress click-away for a short time
                                if (typeof window !== 'undefined') {
                                  window.wfSuppressClickAwayUntil = Date.now() + 500;
                                }
                                setExpanded(isExpanded ? k : false);
                                // Trigger reclamp right after expansion toggles
                                setTimeout(() => window.dispatchEvent(new Event('wf-reclamp-dropdown')), 0);
                            }}
                            onMouseDown={(e) => {
                              // Stop propagation to prevent ClickAwayListener
                              e.stopPropagation();
                              if (typeof window !== 'undefined') {
                                window.wfSuppressClickAwayUntil = Date.now() + 500;
                              }
                            }}
                            onClick={(e) => {
                              // Stop propagation
                              e.stopPropagation();
                              if (typeof window !== 'undefined') {
                                window.wfSuppressClickAwayUntil = Date.now() + 500;
                              }
                            }}
                            key={k + '-accordion'}
                            style={{ backgroundColor: theme.palette.background.paper }}
                            >
                            <AccordionSummary 
                                aria-controls="panel1a-content" 
                                id="panel1a-header" 
                                expandIcon={<ExpandMoreIcon style={{ color: theme.palette.text.primary }} />} 
                                key={k + '-accordionsummary'} 
                                onMouseDown={(e) => {
                                  e.stopPropagation();
                                  if (typeof window !== 'undefined') {
                                    window.wfSuppressClickAwayUntil = Date.now() + 500;
                                  }
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (typeof window !== 'undefined') {
                                    window.wfSuppressClickAwayUntil = Date.now() + 500;
                                  }
                                }}
                                style={{ alignItems: 'center', paddingTop: 0, paddingBottom: 0, position: 'sticky', top: 0, zIndex: 2, backgroundColor: theme.palette.background.paper }}>
                                <div style={{ display: 'flex', alignItems: 'center', width: 28}}>
                                <Avatar alt={v.data.app} src={v.data.icon} className={styleClass.small} />
                                </div>
                                <div key={k + 'dvia'} style={{ width: breakpoint === 'small' ? '140px' : '90%', display: 'flex', alignItems: 'center' }}>
                                    <Typography key={ky} noWrap style={{ fontSize: breakpoint === 'small' ? '12px' : null, color: theme.palette.text.primary }} className={styleClass.accordionheading}>
                                        {i+1}. {v.data.name}
                                    </Typography>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails 
                                key={k + '_' + ky} 
                                onMouseDown={(e) => {
                                  e.stopPropagation();
                                  if (typeof window !== 'undefined') {
                                    window.wfSuppressClickAwayUntil = Date.now() + 500;
                                  }
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (typeof window !== 'undefined') {
                                    window.wfSuppressClickAwayUntil = Date.now() + 500;
                                  }
                                }}
                                style={{ maxHeight: 280, overflowY: 'auto', border: 'none', backgroundColor: theme.palette.background.paper }}>
                                <div key={k + 'dvvvvvvv'} className={styleClass.chiproot}>
                                    {!v.data.testData ? 
                                        <Paper elevation={0} style={{ margin: '8px 12px', padding: '16px', borderRadius: '12px', background: theme.palette.type === 'dark' ? theme.palette.action.hover : '#f7f9ff', border: 'none' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                                                <img alt="Workload" src={'https://cdn.workload.co/wp-content/uploads/workload-icon.png'} style={{ width: 30, height: 30, borderRadius: 6 }} />
                                                <span style={{ fontSize: 18, color: theme.palette.text.primary }}>→</span>
                                                <img alt={v.data.name} src={v.data.icon} style={{ width: 30, height: 30, borderRadius: 6 }} />
                                            </div>
                                            <Typography style={{ fontWeight: 800, marginBottom: 6, color: theme.palette.text.primary }}>First, you need to complete this step</Typography>
                                            <Typography style={{ color: theme.palette.text.secondary, marginBottom: 14 }}>
                                                Configuring the step gives you access to {(v.data.label || v.data.name)}'s data to use in fields like this one. Complete the step, then come back to select its data.
                                            </Typography>
                                            <Button onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); dispatch(elementSelected(k)); window.dispatchEvent(new Event('wf-close-all-dropdowns')); }} variant="contained" color="primary" style={{ textTransform: 'none', fontWeight: 700 }}>Complete this step</Button>
                                        </Paper> : 
                                        <InspectorWrapperWithIcon iconUrl={v.data.icon} nodeKey={k}>
                                            <Inspector2 
                                                id={k} 
                                                key={k} 
                                                data={v.data.testData && typeof v.data.testData === 'object' && 'Output' in v.data.testData ? v.data.testData : { Output: v.data.testData }} 
                                                isExpanded={(keypath, query) => true} 
                                                onClick={(e) => { 
                                                    // Adjust path to account for "Output" wrapper - remove "t." and "Output." prefixes if present
                                                    let adjustedPath = e.path !== 't' ? e.path : '';
                                                    // Remove "t." prefix if present (e.g., "t.Output.field" -> "Output.field")
                                                    if (adjustedPath && adjustedPath.startsWith('t.')) {
                                                        adjustedPath = adjustedPath.substring(2);
                                                    }
                                                    // Remove "Output." prefix if present (e.g., "Output.field" -> "field")
                                                    if (adjustedPath && adjustedPath.startsWith('Output.')) {
                                                        adjustedPath = adjustedPath.substring(7);
                                                    } else if (adjustedPath === 'Output') {
                                                        adjustedPath = '';
                                                    }
                                                    const formattedPath = 'nodes.' + k + '.outputFields' + (adjustedPath ? '.' + adjustedPath : '')
                                            sendData(formattedPath)
                                                }} 
                                            />
                                        </InspectorWrapperWithIcon>
                                    }
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Divider key={ky} />
                    </div>
                )
            }) : null}
        </div>
        </div>
    )
}



function DynamicDropdownAccordion({open, props, parents, ky, setFields, sendData = null, styleClass, fieldLabel}) {
    const theme = useTheme();
    const [tabvalue, setTabValue] = React.useState(0);
    const workflow_id = useSelector(selectWorkflowId)
    const nodeId = useSelector(selectCurrentElement);
    const nodeData = useSelector(selectElementById(nodeId))
    const icon = <RadioButtonUncheckedOutlinedIcon fontSize="small" />;
    const checkedIcon = <RadioButtonCheckedOutlinedIcon fontSize="small" />;
    const [selected, setSelected] = React.useState('');
    const classes = useStyles();
    const dynamic_arr = props.schema.dynamic.split(".")
    const tablabel = dynamic_arr[1]
    const dynamic_app = dynamic_arr[0]
    const dynamic_action = dynamic_arr[2]
    const dynamic_head = dynamic_arr[3]
    const dynamic_key = dynamic_arr[4]
    const dynamic_value = dynamic_arr[5]
    const params = props.schema.params
    const perform = props.schema.perform
    const nodeFields = nodeData?.data?.fields || []
    const selfFieldName =
      props.formContext?.fieldName ||
      props.name ||
      (typeof props.id === 'string' && props.id !== 'root'
        ? props.id.replace(/^root_?/, '').split('_').filter(Boolean).pop()
        : undefined);
    const unmetDeps = getUnmetDynamicParams(
      { name: selfFieldName, schema: props.schema },
      nodeFields
    )
    const depsBlocked = unmetDeps.length > 0
    const depsHint = depsBlocked
      ? `Select ${unmetDeps.map((d) => d.label).join(', ')} first`
      : ''
    const [paginationUrl, setPaginationUrl] = useState()
    const [searchInput, setSearchInput] = useState('');
    const [filteredResults, setFilteredResults] = useState([]);
    const [dd, setDD] = React.useState()
    const [load_dd, setLoadDD] = React.useState(open && !depsBlocked)
    const [ddLoading, setddLoading] = useState(false)
    const [onerror, setOnError] = useState(false)
    const [errormessage, setErrorMessage] = useState()
    const dispatch = useDispatch();
    const [expandedPanels, setExpandedPanels] = React.useState({});
    const [hasExpandedOnce, setHasExpandedOnce] = React.useState(false);
  // Preserve scroll position within the options list to prevent jump-to-top on re-renders
  const listScrollRef = React.useRef(null);
  const lastScrollTopRef = React.useRef(0);
    
   const handleTabChange = (event, newValue) => {
       // Prevent click-away from seeing this interaction
       if (event) { event.stopPropagation(); }
       if (typeof window !== 'undefined') {
         window.wfSuppressClickAwayUntil = Date.now() + 300;
       }
        setTabValue(newValue);
       if (newValue === 0 && !depsBlocked) {
         getDD();
       }
    };
  const hoverOn = () => {
        // no-op to prevent re-renders that can reset scroll position
      }
    
      const hoverOff = () => {
        // no-op to prevent re-renders that can reset scroll position
      }
      const searchItems = (searchValue) => {
        setSearchInput(searchValue)
        if (searchInput !== '') {
       const filteredData =  dd.filter((item) => {
            return Object.values(item).join('').toLowerCase().includes(searchInput.toLowerCase())
        })
        setFilteredResults(filteredData)
        } 
        else {
            setFilteredResults(dd)
        }
    }

    useEffect(() => {
  // Restore scrollTop after data changes
  if (listScrollRef.current) {
    listScrollRef.current.scrollTop = lastScrollTopRef.current || 0;
  }
}, [dd, filteredResults])

// Helper function to extract pagination token from various REST API response patterns
const extractPaginationToken = (response) => {
  const data = response.data;
  const headers = response.headers || {};
  
  // 1. Check for Link header (RFC 5988) - common in REST APIs
  const linkHeader = headers.link || headers.Link;
  if (linkHeader) {
    // Parse Link header: <https://api.example.com/page?cursor=abc>; rel="next"
    const nextLinkMatch = linkHeader.match(/<([^>]+)>;\s*rel=["']?next["']?/i);
    if (nextLinkMatch && nextLinkMatch[1]) {
      return nextLinkMatch[1];
    }
  }
  
  // 2. Check for Slack-style pagination: response_metadata.next_cursor
  if (data.response_metadata && data.response_metadata.next_cursor) {
    return data.response_metadata.next_cursor;
  }
  
  // 3. Check for links array (HAL-style pagination)
  if (data.links && Array.isArray(data.links) && data.links.length > 0) {
    const nextLink = data.links.find(link => link.rel === 'next' || link.rel === undefined);
    if (nextLink) {
      return nextLink.href || nextLink.url || nextLink;
    }
  }
  
  // 4. Check for direct next URL
  if (data.next) {
    return data.next;
  }
  
  // 5. Check for pagination object patterns
  if (data.pagination) {
    if (data.pagination.next_url) return data.pagination.next_url;
    if (data.pagination.next) return data.pagination.next;
    if (data.pagination.next_page_url) return data.pagination.next_page_url;
    if (data.pagination.cursor) return data.pagination.cursor;
  }
  
  // 6. Check for meta pagination patterns
  if (data.meta && data.meta.pagination) {
    if (data.meta.pagination.next_url) return data.meta.pagination.next_url;
    if (data.meta.pagination.next) return data.meta.pagination.next;
    if (data.meta.pagination.cursor) return data.meta.pagination.cursor;
  }
  
  // 7. Check for cursor at root level
  if (data.next_cursor) return data.next_cursor;
  if (data.cursor) return data.cursor;
  
  // 8. Check for page/offset-based pagination (if has_more is true)
  if (data.has_more === true || data.hasMore === true) {
    // Return current page info to increment, handled by backend
    if (data.page) return { type: 'page', value: data.page + 1 };
    if (data.offset !== undefined) return { type: 'offset', value: data.offset + (data.limit || data.pageSize || 50) };
  }
  
  return null;
};

const getDD = (urlOrToken) => {
   const selfFieldName =
     props.formContext?.fieldName ||
     props.name ||
     (typeof props.id === 'string' && props.id !== 'root'
       ? props.id.replace(/^root_?/, '').split('_').filter(Boolean).pop()
       : undefined);
   if (getUnmetDynamicParams({ name: selfFieldName, schema: props.schema }, nodeData?.data?.fields || []).length > 0) {
     setddLoading(false);
     setOnError(false);
     setDD(null);
     return;
   }

   if (urlOrToken) {
   setddLoading(true)
    // Determine if urlOrToken is a full URL or a cursor token
    const isFullUrl = typeof urlOrToken === 'string' && (urlOrToken.startsWith('http://') || urlOrToken.startsWith('https://'));
    
    // For pagination, determine the field name based on the API pattern
    // Common patterns: 'next_cursor' (Slack), 'cursor', 'page_token', or 'url' for full URLs
    let paginationField = [];
    if (isFullUrl) {
      // Full URL pagination - send as url field with loadmore action
      paginationField = [{url: urlOrToken}];
    } else if (typeof urlOrToken === 'object' && urlOrToken.type) {
      // Structured pagination token (page, offset, etc.)
      paginationField = [{[urlOrToken.type]: urlOrToken.value}];
    } else if (typeof urlOrToken === 'string') {
      // String token - could be cursor, next_cursor, page_token, etc.
      // Try common field names - backend can handle which one it needs
      // Most common is next_cursor (Slack) or cursor
      paginationField = [{next_cursor: urlOrToken}];
    } else {
      paginationField = [{url: urlOrToken}];
    }
    
    // Use backend for pagination requests
    var djangoData = {
        operation: 'getDD',
        data: {
            url: nodeData.data.url,
            app: dynamic_app,
            credential: nodeData.data.credential,
            // Use loadmore action for pagination, or preserve original action
            action: isFullUrl ? 'loadmore' : dynamic_action,
            fields: paginationField,
        }
    }

    var config = {
        method: 'post',
        url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller',
        headers: {
            'Content-Type': 'application/json'
        },
        data: djangoData
    }
    axios(config)
    .then(function (response) {
      if (dynamic_head === '0'){
       
        var choicesProperties = response.data.map(choice => {
            let properties = {
              id : choice[dynamic_key],
              name : choice[dynamic_value]
            };
           
            return properties;
           });
      } else {
       
        var choicesProperties = response.data[dynamic_head].map(choice => {
            let properties = {
              id : choice[dynamic_key],
              name : choice[dynamic_value]
            };
           
            return properties;
           });
        }
        var arr = dd || []
        arr = arr.concat(choicesProperties)
        setDD(arr);
        setddLoading(false)
        
        // Extract pagination token using helper function
        const nextPageToken = extractPaginationToken(response);
        if (nextPageToken) {
          setPaginationUrl(nextPageToken);
        } else {
          setPaginationUrl(null);
        }
   })
   .catch(function (error) {
     setddLoading(false);
     setErrorMessage(JSON.stringify(error.message));
     setOnError(true);
   });
} else {
    setddLoading(true)
    let replaced_params = []
    if (params) {
        params.map((param) => { 
        const result = nodeData.data.fields.filter(x => x.name === param.name);

       if (result[0]) {
          // Extract primitive value if it's an object (for dynamic fields with {label, value})
          let paramValue = result[0].value;
          while (paramValue && typeof paramValue === 'object' && !Array.isArray(paramValue) && paramValue !== null && paramValue.hasOwnProperty('value')) {
            const extracted = paramValue.value;
            if (extracted && typeof extracted === 'object' && !Array.isArray(extracted) && extracted !== null && extracted.hasOwnProperty('value')) {
              paramValue = extracted;
            } else {
              paramValue = extracted;
              break;
            }
          }
          replaced_params.push({'name':param.name,'in':'path','value': paramValue})
       } else {
        const body_value = nodeData.data.fields[0].value[param.name]
        // Extract primitive value if it's an object
        let extractedBodyValue = body_value;
        while (extractedBodyValue && typeof extractedBodyValue === 'object' && !Array.isArray(extractedBodyValue) && extractedBodyValue !== null && extractedBodyValue.hasOwnProperty('value')) {
          const extracted = extractedBodyValue.value;
          if (extracted && typeof extracted === 'object' && !Array.isArray(extracted) && extracted !== null && extracted.hasOwnProperty('value')) {
            extractedBodyValue = extracted;
          } else {
            extractedBodyValue = extracted;
            break;
          }
        }
        replaced_params.push({'name':param.name,'in':'path','value': extractedBodyValue})
       }

    })
    }
    var djangoData = {
        operation: 'getDD',
        data: {
            url: nodeData.data.url,
            app: dynamic_app,
            credential: nodeData.data.credential,
            action: dynamic_action,
            fields: replaced_params,
        }
    }

    var config = {
        method: 'post',
        url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller',
        headers: {
            'Content-Type': 'application/json'
        },
        data: djangoData
    }
    axios(config)
    .then(function (response) {
      if (dynamic_head === '0'){
       
        var choicesProperties = response.data.map(choice => {
            let properties = {
              id : choice[dynamic_key],
              name : choice[dynamic_value]
            };
           
            return properties;
           });
      } else {
       
        var choicesProperties = response.data[dynamic_head].map(choice => {
            let properties = {
              id : choice[dynamic_key],
              name : choice[dynamic_value]
            };
           
            return properties;
           });
        }
          setDD(choicesProperties);
          setOnError(false)
          setddLoading(false)
          
          // Extract pagination token using helper function
          const nextPageToken = extractPaginationToken(response);
          if (nextPageToken) {
            setPaginationUrl(nextPageToken);
          } else {
            setPaginationUrl(null);
        }
    })
.catch(function (error) {
    setErrorMessage(JSON.stringify(error.message))
   setOnError(true)
    setddLoading(false)
   
    
});
}
}

if (load_dd === true){
    if (!depsBlocked) {
      getDD()
    }
   setLoadDD(false)
}

const sendDynamicFormSignal = (e, optionLabel) => {
    setLoadDD(true)
    dispatch(loadingperform(true))
    const dataToSend =
      optionLabel != null && optionLabel !== e
        ? { label: optionLabel, value: e }
        : e;
    sendData(dataToSend); 
    var perform_split = perform.split(".")
  
    var site = perform_split[0]
    var field_title = perform_split[1]
    var perform_action = perform_split[2]
    var perform_data_head = perform_split[3]
    var perform_key = perform_split[4]
    var perform_value = perform_split[5]
    var perform_property_name = perform_split[6]
    let replaced_params = []

    if (params) {
        params.map((param) => { 
        const result = nodeData.data.fields.filter(x => x.name === param.name);
        let paramValue = result[0]?.value === undefined ? e : result[0].value;
        // Extract primitive value if it's an object (for dynamic fields with {label, value})
        while (paramValue && typeof paramValue === 'object' && !Array.isArray(paramValue) && paramValue !== null && paramValue.hasOwnProperty('value')) {
          const extracted = paramValue.value;
          if (extracted && typeof extracted === 'object' && !Array.isArray(extracted) && extracted !== null && extracted.hasOwnProperty('value')) {
            paramValue = extracted;
          } else {
            paramValue = extracted;
            break;
          }
        }
        // Prefer the just-selected value for this field's own param name
        const selfName =
          props.formContext?.fieldName ||
          props.name ||
          (typeof props.id === 'string' && props.id !== 'root'
            ? props.id.replace(/^root_?/, '').split('_').filter(Boolean).pop()
            : undefined);
        if (selfName && param.name === selfName) {
          paramValue = e;
        }
        replaced_params.push({'name':param.name,'in': 'path', 'value': paramValue})
    })
    }
    var djangoData = {
        operation: 'getDD',
        data: {
            url: nodeData.data.url,
            app: dynamic_app,
            credential: nodeData.data.credential,
            action: perform_action,
            fields: replaced_params,
        }
    }

    var config = {
        method: 'post',
        url: 'https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller',
        headers: {
            'Content-Type': 'application/json'
        },
        data: djangoData
    }
    axios(config)
    .then(function (response) {
        if (perform_data_head === '0'){
       
            var choicesProperties = response.data.map(choice => {
                let properties = {
                  name : choice[perform_key],
                  title : choice[perform_value]
                };
               
                return properties;
               });
          } else {
           
            var choicesProperties = response.data[perform_data_head].map(choice => {
                let properties = {
                  name : choice[perform_key],
                  title : choice[perform_value]
                };
               
                return properties;
               });
            }
           
            
            if (perform_data_head !== '0') {
               
                var data_start = nodeData.data.fields
                let new_data_start = Object.assign([{}], data_start)
                
                var nds = replaced_params.map((param) => { 
                    var r = new_data_start.find(x => {  return x.name === param.name });
                    
                    var new_new_data_start = Object.assign({}, r, {value: param.value})
                    return new_new_data_start
                  
                   // updated_obj.push(result)
                })
              
                let newdatastart = Object.assign(new_data_start, nds)
                let result = newdatastart.find(obj => {
                    return obj.name === 'body'
                  })
                   if (!result) {
                    const empty_result = {description: " ",in: "path", name: "body", title: " ", value: {}}
                    newdatastart = [...newdatastart, empty_result]
                    result = empty_result
                    dispatch(elementUpdated(nodeData.id,
                        {
                            name: nodeData.data.name,
                            // CRITICAL: Preserve type - use nodeData.data.type if app is empty, otherwise use app
                            type: nodeData.data.app || nodeData.data.type || '',
                            actionlabel: nodeData.data.actionlabel,
                            label: nodeData.data.label,
                            icon: nodeData.data.icon,
                            hasauth: nodeData.data.hasauth,
                            action: nodeData.data.action,
                            credential: nodeData.data.credential,
                            authname: nodeData.data.authname,
                            fields: newdatastart,
                            testData: nodeData.data.testData,
                            url: nodeData.data.url
                        },
                        null,
                        null  // No undo history for internal field updates
                    ));
                   // dispatch(saveWorkflow(1))
                  } 
                //Object.assign({},result, {result: {value:  [{typecast: true}]}})

                  if (perform_property_name !== '0') {
                  var new_data_head = {[perform_property_name ? perform_property_name : perform_data_head]: {'description': field_title, 'title': field_title,'type': 'object', 'properties':{}}}
                  var new_properties = choicesProperties.map(choice => {
                   let n_p = {
                       [choice.name]: {
                            'description': choice.title,
                            'title': choice.title,
                            'type': 'string'
                        }
                    }
                    Object.assign(new_data_head[perform_property_name ? perform_property_name : perform_data_head].properties, n_p)
                    return new_properties
                    
                  })
                } if (perform_property_name === '0') {
                    var new_data_head = {}
                  var new_properties = choicesProperties.map(choice => {
                   let n_p = {
                       [choice.name]: {
                            'description': choice.title,
                            'title': choice.title,
                            'type': 'string'
                        }
                    }
                    Object.assign(new_data_head, n_p)
                    return new_properties
                    
                  })
                }
               
               
                const new_obj = mergePerformBody(result, new_data_head)
              // special line for Airtable performs  const newnew_obj = Object.assign({}, new_obj, {value: {typecast: true}} )
                const newnew_obj = Object.assign({}, new_obj)


                const res = newdatastart.map(obj => [newnew_obj].find(o => o.name === obj.name) || obj);

                
                const new_nodeData = res
                dispatch(elementUpdated(nodeData.id,
                    {
                        name: nodeData.data.name,
                        // CRITICAL: Preserve type - use nodeData.data.type if app is empty, otherwise use app
                        type: nodeData.data.app || nodeData.data.type || '',
                        actionlabel: nodeData.data.actionlabel,
                        label: nodeData.data.label,
                        icon: nodeData.data.icon,
                        hasauth: nodeData.data.hasauth,
                        action: nodeData.data.action,
                        credential: nodeData.data.credential,
                        authname: nodeData.data.authname,
                        fields: new_nodeData,
                        testData: nodeData.data.testData,
                        url: nodeData.data.url
                    },
                    null,
                    null  // No undo history for internal field updates
                ));
                dispatch(saveWorkflow(1))
              
                
                
            } else {
                var data_start = nodeData.data.fields
                const new_data_start = Object.assign([{}], data_start)
                
                var nds = replaced_params.map((param) => { 
                    var r = new_data_start.find(x => {  return x.name === param.name });
                    
                    var new_new_data_start = Object.assign({}, r, {value: param.value})
                    return new_new_data_start
                  
                   // updated_obj.push(result)
                })
              
                const newdatastart = Object.assign(new_data_start, nds)
                let result = newdatastart.find(obj => {
                    return obj.name === 'body'
                  })

    
                  let new_data_head = {'description': field_title, 'title': field_title,'type': 'object', 'properties':{}}
                  var new_properties = choicesProperties.map(choice => {
                   let n_p = {
                       [choice.name]: {
                            'description': choice.title,
                            'title': choice.title,
                            'type': 'string'
                        }
                    }
                    Object.assign(new_data_head.properties, n_p)
                    return new_properties
                    
                  })
               
                // Legacy perform_data_head === '0': schema.properties is an object-schema; merge leaves, keep values
                const prevRoot = result?.schema?.properties || {};
                const prevInner = prevRoot?.properties || {};
                const nextInner = new_data_head?.properties || {};
                const mergedInner = deepMergeSchemaProperties(prevInner, nextInner);
                const mergedRoot = { ...prevRoot, ...new_data_head, properties: mergedInner };
                const prevValue = result?.value && typeof result.value === 'object' && !Array.isArray(result.value) ? result.value : {};
                const new_obj = {
                  ...(result || { description: ' ', in: 'path', name: 'body', title: ' ' }),
                  schema: { ...(result?.schema || {}), properties: mergedRoot },
                  value: preservePerformValues(prevValue, mergedInner),
                };
                const res = newdatastart.map(obj => [new_obj].find(o => o.name === obj.name) || obj);

                 
                const new_nodeData = res
                
                dispatch(elementUpdated(nodeData.id,
                    {
                        name: nodeData.data.name,
                        // CRITICAL: Preserve type - use nodeData.data.type if app is empty, otherwise use app
                        type: nodeData.data.app || nodeData.data.type || '',
                        actionlabel: nodeData.data.actionlabel,
                        label: nodeData.data.label,
                        icon: nodeData.data.icon,
                        hasauth: nodeData.data.hasauth,
                        action: nodeData.data.action,
                        credential: nodeData.data.credential,
                        authname: nodeData.data.authname,
                        fields: new_nodeData,
                        testData: nodeData.data.testData,
                        url: nodeData.data.url
                    },
                    null,
                    null  // No undo history for internal field updates
                ));
                dispatch(saveWorkflow(1))
              
            }
                 
            setLoadDD(false)
            dispatch(loadingperform(false))
          

    })
.catch(function (error) {
   setLoadDD(false)
   dispatch(loadingperform(false))
  
});


}

    function TabPanel(props) {
        const { children, value, index, ...other } = props;
      
        return (
          <div key={index + 'tab'}
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
          >
            {value === index && (
              <Box>
                {children}
              </Box>
            )}
          </div>
        );
      }
      
      TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
      };
      function a11yProps(index) {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
      }

    const inPortal = props?.usePortalLayout;
     const portalSafeStyle = { position: 'static', boxShadow: theme.palette.type === 'dark' ? 'rgba(0, 0, 0, 0.5) 0px 10px 30px 0px' : 'rgba(0, 0, 0, 0.2) 0px 10px 30px 0px', width: 'auto', background: theme.palette.background.paper };

    return (
        <div
        className={inPortal ? undefined : classes.dropdown}
        style={inPortal ? portalSafeStyle : undefined}
        >
        
         {/* Sticky header with close and tabs */}
         <div style={{ position: 'sticky', top: 0, zIndex: 10001, backgroundColor: theme.palette.background.paper, background: theme.palette.background.paper, borderBottom: `1px solid ${theme.palette.divider}`, boxShadow: theme.palette.type === 'dark' ? '0 2px 3px rgba(0,0,0,0.2)' : '0 2px 3px rgba(0,0,0,0.06)', marginBottom: 0 }}>
         <div 
         data-wf-close-button="true"
         style={{
             position: 'absolute',
             top: '12px',
             right: '12px',
             zIndex: 10002,
             cursor: 'pointer',
             width: '28px',
             height: '28px',
             display: 'flex',
             alignItems: 'center',
             justifyContent: 'center',
             borderRadius: '6px',
             fontSize: '16px',
             fontWeight: 'bold',
             border: `2px solid ${theme.palette.background.paper}`,
             boxShadow: theme.palette.type === 'dark' ? '0 2px 4px rgba(0,0,0,0.3)' : '0 2px 4px rgba(0,0,0,0.2)',
             backgroundColor: theme.palette.background.paper,
             color: theme.palette.text.primary
         }}
         onClick={(e) => {
             e.stopPropagation();
             e.preventDefault();
             // Clear suppression flag to ensure close works
             if (typeof window !== 'undefined') {
                 window.wfSuppressClickAwayUntil = 0;
             }
             // Dispatch close event
             window.dispatchEvent(new Event('wf-close-all-dropdowns'));
         }}
         onMouseDown={(e) => {
             e.stopPropagation();
             e.preventDefault();
             // Clear suppression flag in capture phase too
             if (typeof window !== 'undefined') {
                 window.wfSuppressClickAwayUntil = 0;
             }
         }}
         onMouseEnter={(e) => {
             e.target.style.color = theme.palette.primary.main;
         }}
         onMouseLeave={(e) => {
             e.target.style.color = theme.palette.text.primary;
         }}
         >
             <CloseRoundedIcon style={{ fontSize: '18px' }} />
         </div>
           <Typography style={{ fontSize: 14, fontWeight: 900, marginLeft: 25, paddingTop: 25, paddingBottom: 10, backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary}}>Select value for {fieldLabel} <span style={{ fontSize: 12, fontWeight: 400, color: theme.palette.text.secondary, padding: 4, border: `1px solid ${theme.palette.divider}`, borderRadius: '8px'}}><Typography variant="caption"  gutterBottom>{tabvalue === 0 ? 'Static' : 'Dynamic'}</Typography></span></Typography>
           <Tabs style={{ marginBottom: 10, backgroundColor: theme.palette.background.paper }}
                value={tabvalue}
                onChange={handleTabChange}
                 onMouseDownCapture={(e) => {
                   // Make sure click-away doesn't fire while switching tabs, even after list renders
                   e.stopPropagation();
                   if (typeof window !== 'undefined') {
                     window.wfSuppressClickAwayUntil = Date.now() + 1000;
                   }
                 }}
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
                aria-label="icon label tabs example"
            >
                <Tab {...a11yProps(0)} style={{textTransform: 'none'}} label={tablabel} />
                <Tab {...a11yProps(1)} style={{textTransform: 'none'}} label="Custom" />
                
            </Tabs>
         </div>
         <div>
           {tabvalue === 0 ? 
           <TextField onChange={(e) => searchItems(e.target.value)}  style={{ width: '95%', height: '35px', marginBottom: '25px', margin: 10, paddingBottom: 20 }} id="outlined-search" label="Search..." type="search" variant="outlined"
            value={searchInput}
            key='dynamic-search'
           
            placeholder='Search...' 
            InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchRoundedIcon style={{color: theme.palette.text.secondary}} />
                  </InputAdornment>
                ),
              }} /> : null }
           
            <TabPanel value={tabvalue} index={0}>
             <div ref={listScrollRef} onScroll={(e) => { lastScrollTopRef.current = e.currentTarget.scrollTop; }} style={{ maxHeight: '40vh', overflowY: 'auto', paddingBottom: 8, overscrollBehavior: 'contain', overflowAnchor: 'none', position: 'relative' }}>
            {depsBlocked ? (
              <Box style={{ padding: '16px 20px' }}>
                <Typography variant="body2" color="textSecondary">
                  {depsHint}
                </Typography>
              </Box>
            ) : onerror === true ? <>
            <Chip color="secondary" label="Error:" />
            <Typography>{errormessage}</Typography>
            </>
            : dd ? searchInput.length > 1 ? filteredResults.map(option => <div><MenuItem className={classes.radio} id={option.id} key={option.id} onMouseEnter={() => hoverOn(option.id)}
            onMouseLeave={hoverOff}             onMouseDown={(e) => { 
              e.preventDefault();
              e.stopPropagation();
              setSelected(option.id);
              // Send object with label and value for dynamic fields, or just value if label === value
              const dataToSend = option.name === option.id ? option.id : { label: option.name, value: option.id };
              sendData(dataToSend); 
            }} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); setSelected(option.id); const dataToSend = option.name === option.id ? option.id : { label: option.name, value: option.id }; sendData(dataToSend); } }}>
            
            <Radio
              id={option.id}
              key={option.id}
              color='primary'
              checkedIcon={checkedIcon}
              icon={icon}
              style={{ marginRight: 8 }}
              checked={selected === option.id}
              value={option.id}
              onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setSelected(option.id); const dataToSend = option.name === option.id ? option.id : { label: option.name, value: option.id }; sendData(dataToSend); }}
            />
            <Typography style={{color: 'white'}}>{option.name} </Typography>
            
          </MenuItem> <Typography style={{marginTop: '-17px', marginLeft: '62px', fontSize:'11px', color: theme.palette.text.secondary}} align='left' variant="caption" display="block" gutterBottom>{option.id}</Typography>
          </div>
          ): dd.map(option => <div><MenuItem className={classes.radio} id={option.id} key={option.id} onMouseEnter={() => hoverOn(option.id)}
            onMouseLeave={hoverOff}             
            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setSelected(option.id); perform ?  sendDynamicFormSignal(option.id, option.name) : (() => { const dataToSend = option.name === option.id ? option.id : { label: option.name, value: option.id }; sendData(dataToSend); })(); }} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); setSelected(option.id); perform ?  sendDynamicFormSignal(option.id, option.name) : (() => { const dataToSend = option.name === option.id ? option.id : { label: option.name, value: option.id }; sendData(dataToSend); })(); } }}>
            
            <Radio
              id={option.id}
              key={option.id}
              color='primary'
              checkedIcon={checkedIcon}
              icon={icon}
              style={{ marginRight: 8 }}
              checked={selected === option.id}
              value={option.id}
              onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setSelected(option.id); perform ?  sendDynamicFormSignal(option.id, option.name) : (() => { const dataToSend = option.name === option.id ? option.id : { label: option.name, value: option.id }; sendData(dataToSend); })(); }}
            />
            <Typography style={{color: theme.palette.text.primary}} variant='inherit' >{option.name}<br/><div style={{ fontSize:'13px', fontWeight: 400, color: theme.palette.text.secondary}}>{option.id}</div> </Typography>
            
           </MenuItem>
          </div>
          ): <div>
          <LinearProgress color="primary" />
          <Skeleton animation="wave" height={34} style={{ marginTop: 36 }} /> 
          <Skeleton animation="wave" height={18} style={{ marginTop: 6 }} /> 
          <Skeleton animation="wave" height={85} style={{ marginBottom: 6 }} /> 
          <Skeleton animation="wave" height={34} style={{ marginTop: 36 }} /> 
          <Skeleton animation="wave" height={18} style={{ marginTop: 6 }} /> 
          <Skeleton animation="wave" height={85} style={{ marginBottom: 6 }} /> 
          </div>
        }
        </div>
          {/* Sticky bottom action bar inside scroll container */}
          <div style={{
            position: 'sticky',
            bottom: 0,
            zIndex: 100,
            background: theme.palette.background.paper,
            padding: '10px 0',
            borderTop: `1px solid ${theme.palette.divider}`,
            pointerEvents: 'auto'
          }}>
            <Button 
              size='small' 
              disabled={!paginationUrl} 
              style={{
                marginLeft: 10, 
                marginRight: '4%', 
                width: '46%', 
                textTransform: 'none',
                fontWeight: 600, 
                fontSize: '16px', 
                backgroundColor: paginationUrl ? theme.palette.background.paper : (theme.palette.type === 'dark' ? theme.palette.action.hover : 'whitesmoke'), 
                color: paginationUrl ? theme.palette.text.primary : theme.palette.text.secondary
              }} 
              variant='outlined' 
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (paginationUrl) {
                  getDD(paginationUrl);
                }
              }}
            >
              {ddLoading ? <CircularProgress color='default' size={28} /> : 'Load More'}
            </Button>
            <Button 
              size='small' 
              style={{ 
                width: '46%', 
                textTransform: 'none',
                fontWeight: 600, 
                fontSize: '16px', 
                backgroundColor: theme.palette.background.paper, 
                color: theme.palette.text.primary
              }} 
              variant='outlined' 
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                sendData(null);
              }}
            >
              Clear Data
            </Button>
          </div>
           </TabPanel>
            <TabPanel value={tabvalue} index={1}>
                    <div>
            {parents ? Object.entries(parents).map(([k, v], i) => {
                
                const isOpen = expandedPanels && expandedPanels[k] !== undefined ? expandedPanels[k] : (!hasExpandedOnce && i === 0);
                return (
                    <div key={k}>
                        <div 
                          data-wf-accordion="true"
                          onClick={(e) => { 
                            // CRITICAL: Stop all propagation immediately
                            e.stopPropagation();
                            e.preventDefault();
                            if (e.nativeEvent) {
                              e.nativeEvent.stopImmediatePropagation();
                            }
                            // Suppress click-away detection with longer duration
                            if (typeof window !== 'undefined') {
                              window.wfSuppressClickAwayUntil = Date.now() + 1000;
                            }
                            setHasExpandedOnce(true); 
                            setExpandedPanels(() => { const willOpen = !isOpen; return willOpen ? { [k]: true } : {}; }); 
                            setTimeout(() => window.dispatchEvent(new Event('wf-reclamp-dropdown')), 0); 
                          }} 
                          onMouseDown={(e) => {
                            // CRITICAL: Set suppression flag IMMEDIATELY
                            if (typeof window !== 'undefined') {
                              window.wfSuppressClickAwayUntil = Date.now() + 1000;
                            }
                            // Stop propagation on mousedown as well - this fires before click
                            e.stopPropagation();
                            e.preventDefault();
                            if (e.nativeEvent) {
                              e.nativeEvent.stopImmediatePropagation();
                            }
                          }}
                          onMouseDownCapture={(e) => {
                            // CRITICAL: In capture phase, set flag and stop propagation BEFORE document handler
                            if (typeof window !== 'undefined') {
                              window.wfSuppressClickAwayUntil = Date.now() + 1000;
                            }
                            e.stopPropagation();
                            e.preventDefault();
                            if (e.nativeEvent) {
                              e.nativeEvent.stopImmediatePropagation();
                            }
                          }}
                          style={{ display: 'flex', alignItems: 'center', padding: '8px 16px', background: theme.palette.background.paper, cursor: 'pointer', borderTop: `1px solid ${theme.palette.divider}` }}>
                            <div style={{ display: 'flex', alignItems: 'center', width: 28 }}>
                                <Avatar alt={v.data.label} src={v.data.icon} className={classes.small} />
                            </div>
                            <Typography className={classes.accordionheading} style={{ display: 'flex', alignItems: 'center', flex: 1, color: theme.palette.text.primary }}>{i + 1}. {v.data.name}</Typography>
                            <ExpandMoreIcon style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 150ms ease', color: theme.palette.text.primary }} />
                        </div>
                        <div style={{ display: isOpen ? 'block' : 'none', maxHeight: 280, overflowY: 'auto', padding: '8px 0', backgroundColor: theme.palette.background.paper }}>
                                <div className={classes.chiproot}>
                                    {!v.data.testData ? 
                                    <Paper elevation={0} style={{ margin: '8px 12px', padding: '16px', borderRadius: '12px', background: theme.palette.type === 'dark' ? theme.palette.action.hover : '#f7f9ff', border: 'none' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                                            <img alt="Workload" src={'https://cdn.workload.co/wp-content/uploads/workload-icon.png'} style={{ width: 30, height: 30, borderRadius: 6 }} />
                                            <span style={{ fontSize: 18, color: theme.palette.text.primary }}>→</span>
                                            <img alt={v.data.name} src={v.data.icon} style={{ width: 30, height: 30, borderRadius: 6 }} />
                                        </div>
                                        <Typography style={{ fontWeight: 800, marginBottom: 6, color: theme.palette.text.primary }}>First, you need to complete this step</Typography>
                                        <Typography style={{ color: theme.palette.text.secondary, marginBottom: 14 }}>
                                            Configuring the step gives you access to {(v.data.label || v.data.name)}'s data to use in fields like this one. Complete the step, then come back to select its data.
                                        </Typography>
                                        <Button onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); dispatch(elementSelected(k)); window.dispatchEvent(new Event('wf-close-all-dropdowns')); }} variant="contained" color="primary" style={{ textTransform: 'none', fontWeight: 700 }}>Complete this step</Button>
                                    </Paper> : 
                                    <InspectorWrapperWithIcon iconUrl={v.data.icon} nodeKey={k}>
                                        <Inspector2 id={k} key={k} data={v.data.testData && typeof v.data.testData === 'object' && 'Output' in v.data.testData ? v.data.testData : { Output: v.data.testData }} isExpanded={(keypath, query) => true}                                         onClick={(e) => { 
                                            // Stop propagation to prevent document click handler from interfering
                                            if (e && e.stopPropagation) {
                                              e.stopPropagation();
                                            }
                                            // Suppress click-away detection
                                            if (typeof window !== 'undefined') {
                                              window.wfSuppressClickAwayUntil = Date.now() + 500;
                                            }
                                            // Adjust path to account for "Output" wrapper - remove "t." and "Output." prefixes if present
                                            let adjustedPath = e.path != 't' ? e.path : '';
                                            // Remove "t." prefix if present (e.g., "t.Output.field" -> "Output.field")
                                            if (adjustedPath && adjustedPath.startsWith('t.')) {
                                                adjustedPath = adjustedPath.substring(2);
                                            }
                                            // Remove "Output." prefix if present (e.g., "Output.field" -> "field")
                                            if (adjustedPath && adjustedPath.startsWith('Output.')) {
                                                adjustedPath = adjustedPath.substring(7);
                                            } else if (adjustedPath === 'Output') {
                                                adjustedPath = '';
                                            }
                                            const formattedPath = 'nodes.' + k + '.outputFields' + (adjustedPath ? '.' + adjustedPath : '');
                                            const pickedValue = Object.byString(v.data.testData, adjustedPath || '');
                                            const label = typeof pickedValue === 'object' ? JSON.stringify(pickedValue).substring(0, 250) : String(pickedValue);
                                            // Call sendData with the object containing label and value
                                            if (sendData) {
                                              sendData({ label, value: formattedPath });
                                            }
                                        }} />
                                    </InspectorWrapperWithIcon>
                                    }
                                </div>
                        </div>
                        <Divider />
                    </div>
                )
            }) : null}
            </div>
            </TabPanel>
         </div>
        </div> 
    )
}


export function FieldsRender({
  breakpoint,
  fields,
  setFields,
  disabled = false,
  source = "workflow",
  bodyKeyOnly = null,
}) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const nodeId = useSelector(selectCurrentElement);
  const nodeData = useSelector(selectElementById(nodeId));

  // Create muiTheme that inherits from the global theme
  const muiTheme = useMemo(() => createMuiTheme({
    ...theme,
    palette: {
      ...theme.palette,
      primary: { main: '#0069ea' },
      secondary: { main: '#ff5555' }
    },
    props: {
      MuiTextField: {
        variant: 'outlined'
      }
    }
  }), [theme]);

  // Track whether we have fetched data yet
  const [isLoading, setIsLoading] = useState(false);

   // a ref or state to track if we already fetched, so we don't do it again
   const didFetchRef = useRef(false);
  // If you need any local copy of "perform" data, store it here
  // const [performFields, setPerformFields] = useState(null);

  // Suppose we want to track hidden UI items from the schema
  const [uiSchema, setUiSchema] = useState({});

  // Decide which widgets to use
  let widgetSpec = {
    TextWidget: (props) => <WorkflowWidget {...props} />,
    SelectWidget: (props) => <WorkflowWidget {...props} />,
    CheckboxWidget: (props) => <WorkflowWidget {...props} />,
    // Add a key if you used "WorkflowWidget" in uiSchema
    WorkflowWidget: (props) => <WorkflowWidget {...props} />,
    // or if you used "ExecutionWidget" for triggers, etc.
  };
  if (source === "execution") {
    widgetSpec = {
      TextWidget: ExecutionWidget,
    };
  }

  // 1) Generate or gather a deep copy of fields
  //    (So you don't accidentally mutate the original.)
  //    But if `fields` is already from state or a stable source,
  //    you can possibly skip this. For safety:
  const fieldsCopy = useMemo(() => {
    // only recompute if `fields` changes
    return fields ? JSON.parse(JSON.stringify(fields)) : [];
  }, [fields]);
  // 2) On the first pass, fill uiSchema with "hidden" rules if needed
  useEffect(() => {
    if (!fieldsCopy) return;
    const newUiSchema = {};
    const body = fieldsCopy.filter((x) => x.in === "formData");
    if (body.length > 0) {
      const topLevelSchema = body[0]?.schema;
      if (topLevelSchema) {
        const properties =
          topLevelSchema.properties || topLevelSchema.items?.properties;
        if (properties) {
          Object.keys(properties).forEach((key) => {
            const val = properties[key];
            if (val.hidden) {
              newUiSchema[key] = { "ui:widget": () => <div style={{ display: "none" }} /> };
            }
          });
        }
      }
    }
    setUiSchema(newUiSchema);
  }, [fieldsCopy]);

  // 3) Fire the API call only if we have exactly 1 field, no type, but a `perform`.
  //    We'll do this in a useEffect so it only runs once (or whenever conditions change).
  useEffect(() => {
    if (!fieldsCopy || fieldsCopy.length !== 1 || isLoading || didFetchRef.current) {
      return;
    }

    const singleField = fieldsCopy[0];
    // Check for missing type and presence of schema.perform
    const hasPerform = !!singleField?.schema?.perform;
    const missingType = !singleField?.schema?.type;
    if (!hasPerform || !missingType || !nodeData) {
      return;
    }

    // Once we decide we need to fetch, mark as loading:
    didFetchRef.current = true;
    setIsLoading(true);

    if (hasPerform && missingType && nodeData) {
      // We meet the criteria, so fetch
      setIsLoading(true);

      const performSplit = singleField.schema.perform.split(".");
      const [app, field_title, action, perform_data_head, perform_key, perform_value, perform_property_name] = performSplit;

      // Setup your request
      const djangoData = {
        operation: "getDD",
        data: {
          url: nodeData.data.url,
          app: app,
          credential: nodeData.data.credential,
          action: action,
          fields: [],
        },
      };
      const config = {
        method: "post",
        url: "https://7nx4ewphyg.execute-api.us-west-2.amazonaws.com/production/djangocaller",
        headers: {
          "Content-Type": "application/json",
        },
        data: djangoData,
      };

      axios(config)
        .then((response) => {
          const data = response.data;

          // Example: build new fields from `data`
          // (Your original code replaced `fields` with a single "Create Contact" field,
          //  but presumably you actually want to do something with `data`.)
          // For demonstration, let's do something simple:
          const newFields = data.map((item) => {
            return {
              // Hard-code or derive "name" from item if needed
              name: item[perform_key],
      
              // Hard-code or use item for "title"
              title: item[perform_value],
      
              // Provide the schema as needed
              schema: {
                type: "string",
              },
            };
          });
      

          // Save them to the parent
          setFields(newFields);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [fieldsCopy]);

  // 4) If fields is still undefined, or something is missing, return null
  if (!fieldsCopy) {
    return null;
  }

  // 5) If we're in the middle of loading the single field's data, show a spinner
  if (isLoading && fieldsCopy.length === 1 && !fieldsCopy[0]?.schema?.type) {
    return <CircularProgress />;
  }

  // When bodyKeyOnly is set (Override mode), only render the body field so we match Manual mode data flow
  // but show a single key. Use the body field's real index in fieldsCopy so setFields gets the full array.
  const bodyFieldIndex = bodyKeyOnly != null ? fieldsCopy.findIndex((f) => f.name === 'body' && (f.in === 'formData' || !f.in)) : -1;
  const fieldsToRender = bodyKeyOnly != null && bodyFieldIndex >= 0 ? [fieldsCopy[bodyFieldIndex]] : fieldsCopy;

  // 6) Render the form for each field
  return (
      <div>
        {fieldsToRender.map((field, i) => {
          const actualIndex = bodyKeyOnly != null && bodyFieldIndex >= 0 ? bodyFieldIndex : i;
          const { schema, hidden, required, title, description, name } = field;

          if (!schema) {
            return null; // No schema, no form
          }

          // Example: hide if `hidden === true` in field
          if (hidden) {
            return null;
          }

          if (schema.type === "datetime") {
            schema.type = "string"
            return
          }

          // Override mode (bodyKeyOnly): provide custom Add/Remove so "+ Add to Tags" works and remove persists to backend
          const isBodyKeyOnlyForm = bodyKeyOnly != null && field.name === 'body';
          const overrideArrayActions = isBodyKeyOnlyForm ? (() => {
            const bodySchema = field.schema?.properties?.[bodyKeyOnly];
            const itemSchema = bodySchema?.items;
            const isObjectItem = itemSchema && typeof itemSchema === 'object' && (itemSchema.type === 'object' || itemSchema.properties);
            const defaultItem = isObjectItem ? {} : '';
            const idx = actualIndex;
            const onArrayItemAdd = () => {
              setFields((prev) => {
                const list = Array.isArray(prev) ? prev : [];
                const f = list[idx];
                if (!f) return list;
                const bodyVal = f.value && typeof f.value === 'object' && !Array.isArray(f.value) ? f.value : {};
                const current = bodyVal[bodyKeyOnly];
                const arr = Array.isArray(current) ? [...current] : [];
                const next = [...arr, defaultItem];
                const newValue = { ...bodyVal, [bodyKeyOnly]: next };
                return list.map((fieldItem, i) => (i === idx ? { ...fieldItem, value: newValue } : fieldItem));
              });
            };
            const onArrayItemRemove = (index) => {
              setFields((prev) => {
                const list = Array.isArray(prev) ? prev : [];
                const f = list[idx];
                if (!f) return list;
                const bodyVal = f.value && typeof f.value === 'object' && !Array.isArray(f.value) ? f.value : {};
                const current = bodyVal[bodyKeyOnly];
                const arr = Array.isArray(current) ? [...current] : [];
                if (index < 0 || index >= arr.length) return list;
                const next = arr.filter((_, i) => i !== index);
                const newValue = { ...bodyVal, [bodyKeyOnly]: next };
                return list.map((fieldItem, i) => (i === idx ? { ...fieldItem, value: newValue } : fieldItem));
              });
            };
            return { onArrayItemAdd, onArrayItemRemove };
          })() : null;

          return (
            <div key={`div_${actualIndex}`}>
              <br />
              <InputLabel key={`label_${actualIndex}`}>
                <Typography
                  key={`type_${actualIndex}`}
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: theme.palette.text.primary,
                    marginLeft: "8px",
                  }}
                >
                  {required && <span style={{ color: theme.palette.error.main }}>* </span>}
                  {title ?? description ?? name}
                  {required && (
                    <span
                      style={{ color: theme.palette.text.secondary, fontWeight: 600, fontSize: "12px" }}
                    >
                      {" "}
                      (required)
                    </span>
                  )}
                </Typography>
              </InputLabel>

              <MuiThemeProvider key={`provider_${actualIndex}`} theme={muiTheme}>
                <OverrideArrayActionsBridge value={overrideArrayActions}>
                  <Form
                    breakpoint={breakpoint}
                    key={isBodyKeyOnlyForm
                      ? `form_${actualIndex}_${bodyKeyOnly}_${Array.isArray(field.value?.[bodyKeyOnly]) ? field.value[bodyKeyOnly].length : 0}`
                      : `form_${actualIndex}`}
                    schema={schema}
                    uiSchema={uiSchema}
                    disabled={disabled}
                    widgets={widgetSpec}
                    formContext={{
                      fieldTitle: (title ?? description ?? name),
                      fieldName: isBodyKeyOnlyForm ? bodyKeyOnly : name,
                      ...(isBodyKeyOnlyForm ? { bodyKey: bodyKeyOnly, onArrayItemAdd: overrideArrayActions?.onArrayItemAdd, onArrayItemRemove: overrideArrayActions?.onArrayItemRemove } : {}),
                      // Manual mode: persist array remove to parent so read-only view updates (RJSF onChange may not fire on remove)
                      ...(field.name === 'body' && field.schema?.type === 'object' && !isBodyKeyOnlyForm ? {
                        updateBodyArray: (key, newArray) => {
                          const idx = actualIndex;
                          setFields((prev) => {
                            const list = Array.isArray(prev) ? prev : [];
                            const f = list[idx];
                            if (!f) return list;
                            const bodyVal = f.value && typeof f.value === 'object' && !Array.isArray(f.value) ? f.value : {};
                            const newValue = { ...bodyVal, [key]: newArray };
                            return list.map((fieldItem, i) => (i === idx ? { ...fieldItem, value: newValue } : fieldItem));
                          });
                        },
                      } : {}),
                    }}
                    ObjectFieldTemplate={isBodyKeyOnlyForm ? SingleFieldObjectFieldTemplate : undefined}
                    ArrayFieldTemplate={ArrayFieldTemplate}
                    noHTML5Validate
                    liveValidate={false}
                    noValidate={true}
                    formData={field.value}
                    onChange={(e) => {
                      // Do not mutate field (Redux/frozen); create new field and new array
                      let newValue = e.formData;
                      // Scrub body: remove keys with empty values; keep empty arrays. Do NOT sanitize array items here—
                      // RJSF adds ""/null when user clicks "+ Add Item"; if we filter those out the new row disappears.
                      // Sanitization happens on save (scrubBodyInFields / scrubBodyValuesInElements).
                      if (field.name === 'body' && field.schema?.type === 'object' && newValue && typeof newValue === 'object' && !Array.isArray(newValue)) {
                        newValue = Object.fromEntries(
                          Object.entries(newValue).filter(([, v]) => {
                            if (v == null || v === '') return false;
                            if (Array.isArray(v) && v.length === 0) return true;
                            if (typeof v === 'object' && Object.keys(v).length === 0) return false;
                            return true;
                          })
                        );
                      }
                      // Use functional update so we always merge with latest parent state (avoids stale closure
                      // when editing nested arrays and ensures added array items persist to workflow JSON)
                      const idx = actualIndex;
                      setFields((prev) => {
                        const list = Array.isArray(prev) ? prev : [];
                        return list.map((f, i) => (i === idx ? { ...f, value: newValue } : f));
                      });
                    }}
                  >
                    <Fragment />
                  </Form>
                </OverrideArrayActionsBridge>
              </MuiThemeProvider>

              <Typography
                key={`desc_${actualIndex}`}
                style={{
                  fontSize: "0.75rem",
                  fontWeight: 400,
                  color: theme.palette.text.secondary,
                  letterSpacing: "0.03333em",
                  lineHeight: "1.66",
                  marginLeft: "8px",
                  marginTop: "4px",
                }}
              >
                {description ?? ""}
              </Typography>
            </div>
          );
        })}
      </div>
  );
}

/**
 * Renders a single field (or one body key) for Override mode. Auto-saves on change.
 * fieldIndex: index in fields array. bodyKey: when set, edit only this key of the body field.
 */
export function SingleFieldEditor({ fields, setFields, fieldIndex, bodyKey, onClose, breakpoint }) {
  const theme = useTheme();
  const muiTheme = useMemo(() => createMuiTheme({
    ...theme,
    palette: { ...theme.palette, primary: { main: '#0069ea' }, secondary: { main: '#ff5555' } },
    props: { MuiTextField: { variant: 'outlined' } },
  }), [theme]);
  const widgetSpec = useMemo(() => ({
    TextWidget: (props) => <WorkflowWidget {...props} />,
    SelectWidget: (props) => <WorkflowWidget {...props} />,
    CheckboxWidget: (props) => <WorkflowWidget {...props} />,
    WorkflowWidget: (props) => <WorkflowWidget {...props} />,
  }), []);

  const field = fields && fields[fieldIndex];
  if (!field || !field.schema) return null;

  let schema = field.schema;
  let formData = field.value;
  let useFullBodyForm = false;
  if (bodyKey != null && field.name === 'body' && field.schema?.properties?.[bodyKey]) {
    // Use full body schema and formData (same as Manual mode / FieldsRender) so RJSF Add/Remove work.
    // ObjectFieldTemplate will show only the bodyKey property via formContext.bodyKey.
    useFullBodyForm = true;
    schema = field.schema;
    const bodyObj = typeof field.value === 'object' && field.value !== null ? field.value : {};
    formData = { ...bodyObj };
    Object.keys(field.schema?.properties || {}).forEach((key) => {
      if (formData[key] == null && field.schema.properties[key]?.type === 'array') {
        formData[key] = [];
      }
    });
  }

  // Keep latest form data so we can persist it when user clicks Done (covers cases where RJSF doesn't fire onChange on last array item remove)
  const latestFormDataRef = useRef(formData);
  useEffect(() => {
    latestFormDataRef.current = formData;
  }, [formData]);

  const isBodyValueEmpty = (v) => {
    if (v == null || v === '') return true;
    if (Array.isArray(v)) {
      if (v.length === 0) return true;
      const valid = v.filter((x) => x != null && x !== '' && (typeof x !== 'object' || (x && (x.label != null || x.value != null || Object.keys(x).length > 0))));
      return valid.length === 0;
    }
    if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return true;
    return false;
  };

  const sanitizeArrayForBody = (arr) => {
    if (!Array.isArray(arr)) return arr;
    const filtered = arr.filter((x) => x != null && x !== '' && (typeof x !== 'object' || (x && (x.label != null || x.value != null || Object.keys(x).length > 0))));
    return filtered.map((x) => (x && typeof x === 'object' && !Array.isArray(x) ? { ...x } : x));
  };

  const scrubBodyObject = (obj) => {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return obj;
    return Object.fromEntries(
      Object.entries(obj).filter(([, v]) => !isBodyValueEmpty(v)).map(([k, v]) => [k, Array.isArray(v) ? sanitizeArrayForBody(v) : v])
    );
  };

  const buildUpdatedFieldsFromFormData = (formDataToApply) => {
    // Allow '' and null to clear the field; only skip when update is undefined (no change)
    if (bodyKey == null && formDataToApply === undefined) return fields;
    return fields.map((f, i) => {
      if (i !== fieldIndex) return f;
      if (bodyKey != null && field.name === 'body') {
        if (useFullBodyForm && typeof formDataToApply === 'object' && !Array.isArray(formDataToApply)) {
          return { ...f, value: scrubBodyObject(formDataToApply) };
        }
        let newVal = formDataToApply && formDataToApply[bodyKey];
        if (Array.isArray(newVal)) newVal = sanitizeArrayForBody(newVal);
        const base = { ...(typeof f.value === 'object' && f.value ? f.value : {}) };
        if (isBodyValueEmpty(newVal)) {
          delete base[bodyKey];
        } else {
          base[bodyKey] = Array.isArray(newVal)
            ? newVal.map((x) => (x && typeof x === 'object' && !Array.isArray(x) ? { ...x } : x))
            : newVal;
        }
        return { ...f, value: base };
      }
      return { ...f, value: formDataToApply };
    });
  };

  const onArrayItemRemove = (index) => {
    const current = (latestFormDataRef.current && latestFormDataRef.current[bodyKey]) ?? (formData && formData[bodyKey]);
    const arr = Array.isArray(current) ? [...current] : [];
    if (index < 0 || index >= arr.length) return;
    const next = arr.filter((_, i) => i !== index);
    const nextFormData = { ...(latestFormDataRef.current ?? formData), [bodyKey]: next };
    latestFormDataRef.current = nextFormData;
    setFields(buildUpdatedFieldsFromFormData(nextFormData));
  };

  const onArrayItemAdd = () => {
    const bodySchema = field.schema?.properties?.[bodyKey];
    const itemSchema = bodySchema?.items;
    const isObjectItem = itemSchema && typeof itemSchema === 'object' && (itemSchema.type === 'object' || itemSchema.properties);
    const defaultItem = isObjectItem ? {} : '';
    const current = (latestFormDataRef.current && latestFormDataRef.current[bodyKey]) ?? (formData && formData[bodyKey]);
    const arr = Array.isArray(current) ? [...current] : [];
    const next = [...arr, defaultItem];
    const nextFormData = { ...(latestFormDataRef.current ?? formData), [bodyKey]: next };
    latestFormDataRef.current = nextFormData;
    setFields(buildUpdatedFieldsFromFormData(nextFormData));
  };

  // Expose Add/Remove handlers on module-level ref so ArrayFieldTemplate can call them in Override mode (after handlers are defined)
  useEffect(() => {
    if (bodyKey != null) {
      overrideArrayActionsRef.current = { onArrayItemAdd, onArrayItemRemove };
      return () => { overrideArrayActionsRef.current = null; };
    }
  }, [bodyKey, onArrayItemAdd, onArrayItemRemove]);

  const handleChange = (e) => {
    if (!e.formData) return;
    latestFormDataRef.current = e.formData;
    setFields(buildUpdatedFieldsFromFormData(e.formData));
  };

  const handleDone = () => {
    // Blur active element so widgets that commit on blur (e.g. reference picker) flush their value
    const activeEl = document.activeElement;
    if (activeEl && typeof activeEl.blur === 'function') activeEl.blur();
    const codeMirrorInput = activeEl?.closest?.('.CodeMirror')?.CodeMirror?.getInputField?.();
    if (codeMirrorInput && typeof codeMirrorInput.blur === 'function') codeMirrorInput.blur();
    document.querySelectorAll('.CodeMirror').forEach((cm) => {
      try {
        if (cm?.CodeMirror?.getInputField?.()) cm.CodeMirror.getInputField().blur();
      } catch (_) {}
    });
    // Defer persist so blur-triggered onChange (e.g. empty value from CodeMirror onBlur) runs and updates latestFormDataRef
    setTimeout(() => {
      const dataToPersist = latestFormDataRef.current ?? formData;
      setFields(buildUpdatedFieldsFromFormData(dataToPersist));
      onClose?.();
    }, 50);
  };

  const handleRemoveMapping = () => {
    if (bodyKey != null) {
      const current = latestFormDataRef.current ?? formData;
      const next = typeof current === 'object' && current !== null && !Array.isArray(current)
        ? { ...current, [bodyKey]: '' }
        : { [bodyKey]: '' };
      latestFormDataRef.current = next;
      setFields(buildUpdatedFieldsFromFormData(next));
    } else {
      latestFormDataRef.current = '';
      setFields(buildUpdatedFieldsFromFormData(''));
    }
    onClose?.();
  };

  const fieldTitle = bodyKey != null && field.schema?.properties?.[bodyKey]?.title
    ? field.schema.properties[bodyKey].title
    : (field.title ?? field.description ?? field.name ?? '');

  const formContext = useMemo(() => ({
    fieldTitle,
    fieldName: bodyKey != null ? bodyKey : field.name,
    ...(bodyKey != null ? { bodyKey: useFullBodyForm ? bodyKey : undefined, onArrayItemRemove, onArrayItemAdd } : {}),
  }), [fieldTitle, field.name, bodyKey, useFullBodyForm, onArrayItemRemove, onArrayItemAdd]);

  // Key the Form to force remount when switching fields/bodyKeys so RJSF initializes properly (but not on formData changes)
  const formKey = `${fieldIndex}-${bodyKey || 'root'}`;

  const overrideActionsValue = bodyKey != null ? { onArrayItemAdd, onArrayItemRemove } : null;

  return (
    <MuiThemeProvider theme={muiTheme}>
      <OverrideArrayActionsContext.Provider value={overrideActionsValue}>
        <Form
          key={formKey}
          breakpoint={breakpoint}
          schema={schema}
          uiSchema={{}}
          formData={formData}
          widgets={widgetSpec}
          formContext={formContext}
          ArrayFieldTemplate={ArrayFieldTemplate}
          ObjectFieldTemplate={useFullBodyForm ? SingleFieldObjectFieldTemplate : undefined}
          noHTML5Validate
          liveValidate={false}
          noValidate
          onChange={handleChange}
        >
          <Fragment />
        </Form>
      </OverrideArrayActionsContext.Provider>
      {onClose && (
        <Box style={{ marginTop: 8, marginLeft: 12, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <Button size="small" variant="contained" color="primary" onClick={handleDone}>
            Done
          </Button>
          <Button size="small" variant="text" onClick={handleRemoveMapping} style={{ color: '#666' }}>
            Remove mapping
          </Button>
        </Box>
      )}
    </MuiThemeProvider>
  );
}